<template>

  <!-- Tabs View-->
  <div class="ed-menu-control" id="stickyEditorElement">

    <div v-if="edit">
      <button @click="setWView" :class="{ 'tab-selected': isWView === true }">
      WYSIWYG
      </button>
      <button @click="setHView" :class="{ 'tab-selected': isHView === true }">
        HTML
      </button>

      <button @click="outputHtml">
        Preview
      </button>

    </div>


    <!-- Menu editor -->
    <div class="edit_menu" v-if="edit">

      <!-- Undo|Redo -->
      <button class="edit light" title="Undo" @click="editor.chain().focus().undo().run()" :disabled="!editor.can().undo()">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="28" height="24" viewBox="0 0 28 24" xml:space="preserve">
          <g transform="matrix(1 0 0 1 14.45 12.48)"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"  transform=" translate(-15.95, -16.01)" d="M 12.7 7.1 V 6 c 0 -0.8 -0.4 -1.5 -1.1 -1.8 c -0.7 -0.3 -1.4 -0.2 -2 0.2 l -6.7 6 C 2.3 10.8 2 11.4 2 12 s 0.3 1.2 0.7 1.6 l 6.8 6 c 0.6 0.4 1.3 0.5 2 0.2 c 0.7 -0.3 1.1 -1 1.1 -1.8 v -1 c 6.6 0.1 12.7 4.1 15.4 10.4 c 0.2 0.4 0.5 0.6 0.9 0.6 c 0.1 0 0.1 0 0.2 0 c 0.5 -0.1 0.8 -0.5 0.8 -1 C 30 16.7 22.5 8.2 12.7 7.1 z" stroke-linecap="round" />
          </g>
        </svg>
      </button>
      <button class="edit light" title="Redo" @click="editor.chain().focus().redo().run()" :disabled="!editor.can().redo()">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="28" height="24" viewBox="0 0 28 24" xml:space="preserve">
          <g transform="matrix(-1 0 0 1 14.45 12.49)" id="Icons"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"  transform=" translate(-15.95, -16.01)" d="M 12.7 7.1 V 6 c 0 -0.8 -0.4 -1.5 -1.1 -1.8 c -0.7 -0.3 -1.4 -0.2 -2 0.2 l -6.7 6 C 2.3 10.8 2 11.4 2 12 s 0.3 1.2 0.7 1.6 l 6.8 6 c 0.6 0.4 1.3 0.5 2 0.2 c 0.7 -0.3 1.1 -1 1.1 -1.8 v -1 c 6.6 0.1 12.7 4.1 15.4 10.4 c 0.2 0.4 0.5 0.6 0.9 0.6 c 0.1 0 0.1 0 0.2 0 c 0.5 -0.1 0.8 -0.5 0.8 -1 C 30 16.7 22.5 8.2 12.7 7.1 z" stroke-linecap="round" />
          </g>
        </svg>
      </button>

      <!-- Paragraph | Heading -->
      <button class="edit light" title="Paragraph" @click="editor.chain().focus().setParagraph().run()" :class="{ 'is-active': getHeading() }">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.2273 8.01705H13.7045V15.6023H12.8807C11.8485 15.6023 10.9749 15.4058 10.2599 15.0128C9.54498 14.6151 9.00284 14.0729 8.63352 13.3864C8.2642 12.6951 8.07955 11.9091 8.07955 11.0284C8.07955 10.1572 8.2642 9.37831 8.63352 8.69176C9.00284 8.00047 9.54498 7.45597 10.2599 7.05824C10.9749 6.65578 11.8485 6.45455 12.8807 6.45455H17.2273V8.01705ZM15.4659 21V6.45455H17.2273V21H15.4659Z" fill="black"/>
        </svg>
      </button>

      <select id="headSelect" ref="headSelect" @change="setHeading($event)" title="Heading">
        <option v-for="(option, index) in headOptions" :value="option.text"
          :key="index" >
          {{ option.text }}
        </option>
      </select>

      <!-- Align Left Center Right Justify Unset -->
      <button class="edit light" title="Align left" @click="editor.chain().focus().setTextAlign('left').run()" :class="{ 'is-active': editor.isActive({ textAlign: 'left' }) }">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="2" y1="6" x2="24" y2="6" stroke="black" stroke-width="2"/>
          <line x1="2" y1="16" x2="24" y2="16" stroke="black" stroke-width="2"/>
          <line x1="2" y1="21" x2="18" y2="21" stroke="black" stroke-width="2"/>
          <line x1="2" y1="11" x2="18" y2="11" stroke="black" stroke-width="2"/>
        </svg>
      </button>
      <button class="edit light" title="Align center" @click="editor.chain().focus().setTextAlign('center').run()" :class="{ 'is-active': editor.isActive({ textAlign: 'center' }) }">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="2" y1="6" x2="24" y2="6" stroke="black" stroke-width="2"/>
          <line x1="2" y1="16" x2="24" y2="16" stroke="black" stroke-width="2"/>
          <line x1="6" y1="21" x2="20" y2="21" stroke="black" stroke-width="2"/>
          <line x1="6" y1="11" x2="20" y2="11" stroke="black" stroke-width="2"/>
        </svg>
      </button>
      <button class="edit light" title="Align right" @click="editor.chain().focus().setTextAlign('right').run()" :class="{ 'is-active': editor.isActive({ textAlign: 'right' }) }">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="2" y1="6" x2="24" y2="6" stroke="black" stroke-width="2"/>
          <line x1="2" y1="16" x2="24" y2="16" stroke="black" stroke-width="2"/>
          <line x1="8" y1="21" x2="24" y2="21" stroke="black" stroke-width="2"/>
          <line x1="8" y1="11" x2="24" y2="11" stroke="black" stroke-width="2"/>
        </svg>
      </button>
      <button class="edit light" title="Align justify" @click="editor.chain().focus().setTextAlign('justify').run()" :class="{ 'is-active': editor.isActive({ textAlign: 'justify' }) }">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="2" y1="6" x2="24" y2="6" stroke="black" stroke-width="2"/>
          <line x1="2" y1="16" x2="24" y2="16" stroke="black" stroke-width="2"/>
          <line x1="2" y1="21" x2="24" y2="21" stroke="black" stroke-width="2"/>
          <line x1="2" y1="11" x2="24" y2="11" stroke="black" stroke-width="2"/>
        </svg>
      </button>
      <button class="edit light" title="Unset align" @click="editor.chain().focus().unsetTextAlign().run()">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="2" y1="6" x2="24" y2="6" stroke="black" stroke-width="2"/>
          <line x1="4" y1="16" x2="22" y2="16" stroke="black" stroke-width="2"/>
          <line x1="2" y1="21" x2="16" y2="21" stroke="black" stroke-width="2"/>
          <line x1="6" y1="11" x2="18" y2="11" stroke="black" stroke-width="2"/>
        </svg>
      </button>

      <!-- Font Family -->
      <select id="fontSelect" ref="fontSelect" @change="setFontFamily($event)" title="Font family">
        <option v-for="(option, index) in fontOptions" :value="option.text"
          :key="index" >
          {{ option.text }}
        </option>
      </select>

      <button class="edit light" v-if="getFontFamily()" @click="editor.chain().focus().unsetFontFamily().run()" title="Unset font family">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_uFF)">
          <path d="M8.356 2.368L9.056 2.144C9.69067 2.144 10.008 2.984 10.008 4.664L10.876 11.132L10.988 11.244L14.208 10.068C14.6373 10.068 14.8707 10.3947 14.908 11.048C14.908 11.5333 13.7227 12.1213 11.352 12.812L11.24 12.868V12.98C11.24 13.372 11.856 15.416 13.088 19.112V19.168C13.088 19.5227 12.7987 19.8213 12.22 20.064C11.6787 20.064 11.324 19.42 11.156 18.132C10.7267 17.1987 10.204 15.6587 9.588 13.512H9.476C7.03067 14.016 5.808 14.4453 5.808 14.8C4.464 17.712 3.44667 19.168 2.756 19.168C2.364 19.168 2.13067 18.916 2.056 18.412C2.056 17.964 2.55067 17.0867 3.54 15.78L3.988 14.8H3.288L2.756 14.912C2.06533 14.744 1.72 14.3893 1.72 13.848C2 13.1947 2.41067 12.868 2.952 12.868L3.652 13.148C4.69733 13.148 5.22 12.7653 5.22 12C6.172 9.76 7.21733 6.54933 8.356 2.368ZM8.608 7.464L6.956 12.448C8.48667 12.1493 9.252 11.86 9.252 11.58C8.972 8.836 8.75733 7.464 8.608 7.464Z" fill="black"/>
          <path d="M24.6953 25C24.6953 24.6406 24.5781 24.4453 24.3438 24.4141C24.2656 24.3984 24.1875 24.3906 24.1094 24.3906H23.3594L17.9219 10.9375H16.6797L11.4766 24.3906H10V25H14.2188C14.2188 24.6562 14.1172 24.4609 13.9141 24.4141C13.8203 24.3984 13.7266 24.3906 13.6328 24.3906H12.4141L14.1484 19.8438H18.9531L20.7109 24.3906H19.1406V25H24.6953ZM18.6719 19.1641H14.4062L16.5391 13.6094L18.6719 19.1641Z" fill="black"/>
          <line x1="26.5355" y1="1.46449" x2="19.4645" y2="8.53556" stroke="black" stroke-width="2"/>
          <line x1="19.4645" y1="1.46446" x2="26.5356" y2="8.53553" stroke="black" stroke-width="2"/>
          </g>
          <defs>
          <clipPath id="clip0_uFF">
            <rect width="28" height="28" fill="white"/>
          </clipPath>
          </defs>
        </svg>
      </button>

      <!-- Font Size -->
      <select id="sizeSelect" ref="sizeSelect" @change="setFontSize($event)" title="Font size" >
        <option v-for="(option, index) in sizeOptions" :value="option.text"
          :key="index" >
          {{ option.text }}
        </option>
      </select>

      <button class="edit light" v-if="getFontSize()" @click="editor.chain().focus().unsetFontSize().run()" title="Unset font size">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_uFS)">
          <path d="M16.6953 22C16.6953 21.6406 16.5781 21.4453 16.3438 21.4141C16.2656 21.3984 16.1875 21.3906 16.1094 21.3906H15.3594L9.92188 7.9375H8.67969L3.47656 21.3906H2V22H6.21875C6.21875 21.6562 6.11719 21.4609 5.91406 21.4141C5.82031 21.3984 5.72656 21.3906 5.63281 21.3906H4.41406L6.14844 16.8438H10.9531L12.7109 21.3906H11.1406V22H16.6953ZM10.6719 16.1641H6.40625L8.53906 10.6094L10.6719 16.1641Z" fill="black"/>
          <line x1="26.5355" y1="1.46449" x2="19.4645" y2="8.53556" stroke="black" stroke-width="2"/>
          <line x1="19.4645" y1="1.46446" x2="26.5356" y2="8.53553" stroke="black" stroke-width="2"/>
          <path d="M20 22L22.8868 17L17.1132 17L20 22ZM19.5 17L19.5 17.5L20.5 17.5L20.5 17L19.5 17Z" fill="black"/>
          <path d="M20 10L17.1132 15L22.8868 15L20 10ZM20.5 15L20.5 14.5L19.5 14.5L19.5 15L20.5 15Z" fill="black"/>
          </g>
          <defs>
          <clipPath id="clip0_uFS">
          <rect width="28" height="28" fill="white"/>
          </clipPath>
          </defs>
        </svg>
      </button>

      <!-- Line spacing -->
      <select id="heightSelect" ref="heightSelect" @change="setLineHight($event)" title="Line spacing" >
        <option v-for="(option, index) in heightOptions" :value="option.text"
          :key="index" >
          {{ option.text }}
        </option>
      </select>

      <button class="edit light" v-if="getLineHeight()" @click="editor.chain().focus().unsetLineHeight().run()" title="Unset Line spacing">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_uLH)">
          <line x1="26.5355" y1="1.46449" x2="19.4645" y2="8.53556" stroke="black" stroke-width="2"/>
          <line x1="19.4645" y1="1.46446" x2="26.5356" y2="8.53553" stroke="black" stroke-width="2"/>
          <path d="M20 24L22.8868 19L17.1132 19L20 24ZM19.5 19L19.5 19.5L20.5 19.5L20.5 19L19.5 19Z" fill="black"/>
          <path d="M20 10L17.1132 15L22.8868 15L20 10ZM20.5 15L20.5 14.5L19.5 14.5L19.5 15L20.5 15Z" fill="black"/>
          <line x1="2" y1="11" x2="14" y2="11" stroke="black" stroke-width="2"/>
          <line x1="2" y1="17" x2="14" y2="17" stroke="black" stroke-width="2"/>
          <line x1="2" y1="23" x2="14" y2="23" stroke="black" stroke-width="2"/>
          </g>
          <defs>
          <clipPath id="clip0_uLH">
            <rect width="28" height="28" fill="white"/>
          </clipPath>
          </defs>
          </svg>
      </button>

      <!-- Color Text Background -->
      <input title="Text color"
        type="color"
        @input="editor.chain().focus().setColor($event.target.value).run()"
        :value="editor.getAttributes('textStyle').color"
        id="text_color"
      >
      <button class="edit light" v-if="getTextColor()" @click="editor.chain().focus().unsetColor().run()" title="Unset text color">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_uC)">
          <path d="M16.6953 22C16.6953 21.6406 16.5781 21.4453 16.3438 21.4141C16.2656 21.3984 16.1875 21.3906 16.1094 21.3906H15.3594L9.92188 7.9375H8.67969L3.47656 21.3906H2V22H6.21875C6.21875 21.6562 6.11719 21.4609 5.91406 21.4141C5.82031 21.3984 5.72656 21.3906 5.63281 21.3906H4.41406L6.14844 16.8438H10.9531L12.7109 21.3906H11.1406V22H16.6953ZM10.6719 16.1641H6.40625L8.53906 10.6094L10.6719 16.1641Z" fill="black"/>
          <line x1="26.5355" y1="1.46449" x2="19.4645" y2="8.53556" stroke="black" stroke-width="2"/>
          <line x1="19.4645" y1="1.46446" x2="26.5356" y2="8.53553" stroke="black" stroke-width="2"/>
          <line x1="24" y1="11.8038" x2="21" y2="17" stroke="black" stroke-width="2"/>
          <mask id="path-5-inside-1_1_4" fill="white">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M21.732 19.732C22.5605 18.2972 22.4566 16.6863 21.5 16.134C20.5434 15.5817 19.0964 16.2972 18.2679 17.732L21.732 19.732Z"/>
          </mask>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M21.732 19.732C22.5605 18.2972 22.4566 16.6863 21.5 16.134C20.5434 15.5817 19.0964 16.2972 18.2679 17.732L21.732 19.732Z" fill="black"/>
          <path d="M21.732 19.732L21.232 20.5981L22.0981 21.0981L22.5981 20.232L21.732 19.732ZM18.2679 17.732L17.4019 17.232L16.9019 18.0981L17.7679 18.5981L18.2679 17.732ZM21 17C21.0986 17.0569 21.2593 17.2297 21.2875 17.6664C21.3151 18.0947 21.1953 18.6617 20.866 19.232L22.5981 20.232C23.0972 19.3675 23.3397 18.4116 23.2833 17.5377C23.2275 16.6721 22.8579 15.7633 22 15.2679L21 17ZM19.134 18.232C19.4632 17.6617 19.8944 17.2745 20.2791 17.0842C20.6714 16.8903 20.9014 16.943 21 17L22 15.2679C21.1421 14.7726 20.1702 14.907 19.3927 15.2914C18.6077 15.6796 17.9011 16.3675 17.4019 17.232L19.134 18.232ZM17.7679 18.5981L21.232 20.5981L22.232 18.866L18.7679 16.866L17.7679 18.5981Z" fill="black" mask="url(#path-5-inside-1_1_4)"/>
          <path d="M19.5211 19.8989L19.1924 20.1308L19.2289 19.7303L19.5211 19.8989Z" fill="black" stroke="black" stroke-width="2"/>
          </g>
          <defs>
          <clipPath id="clip0_uC">
          <rect width="28" height="28" fill="white"/>
          </clipPath>
          </defs>
        </svg>
      </button>
      
      <input title="Text background color"
        type="color"
        @input="editor.chain().focus().setBackgroundColor($event.target.value).run()"
        :value="editor.getAttributes('textStyle').backgroundColor"
        id="text_backgroundcolor"
      >
      <button class="edit light" v-if="getTextBackgroundColor()" @click="editor.chain().focus().unsetBackgroundColor().run()" title="Unset text backgroundcolor">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_uBC)">
          <line x1="26.5355" y1="1.46449" x2="19.4645" y2="8.53556" stroke="black" stroke-width="2"/>
          <line x1="19.4645" y1="1.46446" x2="26.5356" y2="8.53553" stroke="black" stroke-width="2"/>
          <mask id="path-3-inside-1_1_4" fill="white">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10 19V25H24V11H18V19H10Z"/>
          </mask>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10 19V25H24V11H18V19H10Z" fill="black"/>
          <path d="M10 25H9V26H10V25ZM10 19V18H9V19H10ZM24 25V26H25V25H24ZM24 11H25V10H24V11ZM18 11V10H17V11H18ZM18 19V20H19V19H18ZM11 25V19H9V25H11ZM24 24H10V26H24V24ZM23 11V25H25V11H23ZM18 12H24V10H18V12ZM17 11V19H19V11H17ZM18 18H10V20H18V18Z" fill="black" mask="url(#path-3-inside-1_1_4)"/>
          <path d="M16.5312 17C16.5312 16.6406 16.4062 16.4453 16.1562 16.4141C16.0781 16.3984 16 16.3906 15.9219 16.3906H15.1484L9.75781 2.9375H8.70312L3.47656 16.3906H2V17H6.19531C6.19531 16.6406 6.07812 16.4453 5.84375 16.4141C5.76562 16.3984 5.6875 16.3906 5.60938 16.3906H4.41406L6.17188 11.8438H11.0234L12.7812 16.3906H11.2109V17H16.5312ZM10.7422 11.1641H6.42969L8.58594 5.5625L10.7422 11.1641Z" fill="black"/>
          </g>
          <defs>
          <clipPath id="clip0_uBC">
          <rect width="28" height="28" fill="white"/>
          </clipPath>
          </defs>
        </svg>
      </button>


      <!-- Mark content -->
      <button class="edit light" title="Bold" @click="editor.chain().focus().toggleBold().run()" :class="{ 'is-active': editor.isActive('bold') }">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.2642 21V6.45455H14.0881C15.1581 6.45455 16.0507 6.61316 16.7656 6.9304C17.4806 7.24763 18.018 7.68797 18.3778 8.25142C18.7377 8.81013 18.9176 9.45407 18.9176 10.1832C18.9176 10.7514 18.804 11.2509 18.5767 11.6818C18.3494 12.108 18.0369 12.4583 17.6392 12.733C17.2462 13.0028 16.7964 13.1946 16.2898 13.3082V13.4503C16.8438 13.474 17.3622 13.6302 17.8452 13.919C18.3329 14.2079 18.7282 14.6127 19.0312 15.1335C19.3343 15.6496 19.4858 16.2652 19.4858 16.9801C19.4858 17.7519 19.294 18.4408 18.9105 19.0469C18.5317 19.6482 17.9706 20.1241 17.2273 20.4744C16.4839 20.8248 15.5677 21 14.4787 21H8.2642ZM11.3395 18.4858H13.8466C14.7036 18.4858 15.3286 18.3224 15.7216 17.9957C16.1146 17.6643 16.3111 17.224 16.3111 16.6747C16.3111 16.2723 16.214 15.9171 16.0199 15.6094C15.8258 15.3016 15.5488 15.0601 15.1889 14.8849C14.8338 14.7098 14.41 14.6222 13.9176 14.6222H11.3395V18.4858ZM11.3395 12.5412H13.6193C14.0407 12.5412 14.4148 12.4678 14.7415 12.321C15.0729 12.1695 15.3333 11.9564 15.5227 11.6818C15.7169 11.4072 15.8139 11.0781 15.8139 10.6946C15.8139 10.169 15.6269 9.74527 15.2528 9.4233C14.8835 9.10133 14.358 8.94034 13.6761 8.94034H11.3395V12.5412Z" fill="black"/>
        </svg>
      </button>
      <button class="edit light" title="Italic" @click="editor.chain().focus().toggleItalic().run()" :class="{ 'is-active': editor.isActive('italic') }">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.24 22L10.52 20.32H12.34L14.34 8.94H12.54L12.84 7.26H18.26L17.96 8.94H16.16L14.16 20.32H15.96L15.66 22H10.24Z" fill="black"/>
        </svg>
      </button>
      <button class="edit light" title="Highlight" @click="editor.chain().focus().toggleHighlight().run()" :class="{ 'is-active': editor.isActive('highlight') }">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="6" y="4" width="17" height="19" fill="black"/>
          <path d="M8.2642 21V6.45455H11.3395V12.456H17.5824V6.45455H20.6506V21H17.5824V14.9915H11.3395V21H8.2642Z" fill="white"/>
        </svg>
      </button>
      <button class="edit light" title="Underline" @click="editor.chain().focus().toggleUnderline().run()" :class="{ 'is-active': editor.isActive('underline') }">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.2486 6.45455H20.3239V15.9006C20.3239 16.9612 20.0705 17.8892 19.5639 18.6847C19.062 19.4801 18.3589 20.1004 17.4545 20.5455C16.5502 20.9858 15.4967 21.206 14.294 21.206C13.0866 21.206 12.0308 20.9858 11.1264 20.5455C10.2221 20.1004 9.51894 19.4801 9.01705 18.6847C8.51515 17.8892 8.2642 16.9612 8.2642 15.9006V6.45455H11.3395V15.6378C11.3395 16.1918 11.4602 16.6842 11.7017 17.1151C11.9479 17.5459 12.2936 17.8845 12.7386 18.1307C13.1837 18.3769 13.7022 18.5 14.294 18.5C14.8906 18.5 15.4091 18.3769 15.8494 18.1307C16.2945 17.8845 16.6378 17.5459 16.8793 17.1151C17.1255 16.6842 17.2486 16.1918 17.2486 15.6378V6.45455Z" fill="black"/>
          <line x1="7" y1="24" x2="22" y2="24" stroke="black" stroke-width="2"/>
        </svg>
      </button>
      <button class="edit light" title="Strike" @click="editor.chain().focus().toggleStrike().run()" :class="{ 'is-active': editor.isActive('strike') }">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.7159 10.0909C16.6307 9.37121 16.285 8.8125 15.679 8.41477C15.0729 8.01705 14.3295 7.81818 13.4489 7.81818C12.8049 7.81818 12.2415 7.92235 11.7585 8.13068C11.2803 8.33901 10.9063 8.62547 10.6364 8.99006C10.3712 9.35464 10.2386 9.76894 10.2386 10.233C10.2386 10.6212 10.331 10.955 10.5156 11.2344C10.705 11.509 10.9465 11.7386 11.2401 11.9233C11.5336 12.1032 11.8414 12.2524 12.1634 12.3707C12.4853 12.4844 12.7812 12.5767 13.0511 12.6477L14.5284 13.0455C14.9072 13.1449 15.3286 13.2822 15.7926 13.4574C16.2614 13.6326 16.7088 13.8717 17.1349 14.1747C17.5658 14.473 17.9209 14.8565 18.2003 15.3253C18.4796 15.794 18.6193 16.3693 18.6193 17.0511C18.6193 17.8371 18.4134 18.5473 18.0014 19.1818C17.5942 19.8163 16.9976 20.3205 16.2116 20.6946C15.4304 21.0687 14.4811 21.2557 13.3636 21.2557C12.322 21.2557 11.42 21.0876 10.6577 20.7514C9.90009 20.4152 9.3035 19.9465 8.8679 19.3452C8.43703 18.7438 8.19318 18.0455 8.13636 17.25H9.95455C10.0019 17.7992 10.1866 18.2538 10.5085 18.6136C10.8352 18.9687 11.2472 19.2339 11.7443 19.4091C12.2462 19.5795 12.786 19.6648 13.3636 19.6648C14.036 19.6648 14.6397 19.5559 15.1747 19.3381C15.7098 19.1155 16.1335 18.8078 16.446 18.4148C16.7585 18.017 16.9148 17.553 16.9148 17.0227C16.9148 16.5398 16.7798 16.1468 16.5099 15.8438C16.2401 15.5407 15.8849 15.2945 15.4446 15.1051C15.0043 14.9157 14.5284 14.75 14.017 14.608L12.2273 14.0966C11.0909 13.7699 10.1913 13.3035 9.52841 12.6974C8.86553 12.0914 8.53409 11.2983 8.53409 10.3182C8.53409 9.50379 8.75426 8.79356 9.1946 8.1875C9.63968 7.5767 10.2363 7.10322 10.9844 6.76705C11.7372 6.42614 12.5777 6.25568 13.5057 6.25568C14.4432 6.25568 15.2765 6.42377 16.0057 6.75994C16.7348 7.09138 17.3125 7.54593 17.7386 8.12358C18.1695 8.70123 18.3968 9.35701 18.4205 10.0909H16.7159Z" fill="black"/>
          <path d="M7 14.4517H19.7557V15.8153H7V14.4517Z" fill="black"/>
        </svg>
      </button>
      <button class="edit light" title="Code" @click="editor.chain().focus().toggleCode().run()" :class="{ 'is-active': editor.isActive('code') }">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.61364 15.9091V15L8.93182 11.2727V12.7273L3.31818 15.4318L3.36364 15.3409V15.5682L3.31818 15.4773L8.93182 18.1818V19.6364L1.61364 15.9091ZM15.8878 7.81818L12.1378 21.75H10.9105L14.6605 7.81818H15.8878ZM25.1818 15.9091L17.8636 19.6364V18.1818L23.4773 15.4773L23.4318 15.5682V15.3409L23.4773 15.4318L17.8636 12.7273V11.2727L25.1818 15V15.9091Z" fill="black"/>
        </svg>
      </button>
      <button class="edit light" title="Subscript" @click="editor.chain().focus().toggleSubscript().run()" :class="{ 'is-active': editor.isActive('subscript') }">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.78409 10.0909L9.39773 14.5511L12.0114 10.0909H13.9432L10.4205 15.5455L13.9432 21H12.0114L9.39773 16.767L6.78409 21H4.85227L8.31818 15.5455L4.85227 10.0909H6.78409ZM15.7951 23.5V22.392L19.119 19.4375C19.4504 19.1439 19.7274 18.8812 19.9499 18.6491C20.1725 18.4171 20.3406 18.1922 20.4542 17.9744C20.5678 17.7566 20.6246 17.5246 20.6246 17.2784C20.6246 16.8523 20.4613 16.5137 20.1346 16.2628C19.8079 16.0118 19.4031 15.8864 18.9201 15.8864C18.4087 15.8864 17.9968 16.0237 17.6843 16.2983C17.3718 16.5682 17.2156 16.9233 17.2156 17.3636H15.7383C15.7383 16.554 16.0389 15.9029 16.6403 15.4105C17.2416 14.9134 18.011 14.6648 18.9485 14.6648C19.5735 14.6648 20.1228 14.7784 20.5962 15.0057C21.0697 15.2282 21.439 15.536 21.7042 15.929C21.9693 16.3172 22.1019 16.7576 22.1019 17.25C22.1019 17.6383 22.0238 17.9981 21.8675 18.3295C21.7113 18.661 21.4674 19.0043 21.136 19.3594C20.8046 19.7145 20.3784 20.1193 19.8576 20.5739L18.011 22.1932V22.25H22.3576V23.5H15.7951Z" fill="black"/>
        </svg>
      </button>
      <button class="edit light" title="Superscript" @click="editor.chain().focus().toggleSuperscript().run()" :class="{ 'is-active': editor.isActive('superscript') }">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.78409 10.0909L9.39773 14.5511L12.0114 10.0909H13.9432L10.4205 15.5455L13.9432 21H12.0114L9.39773 16.767L6.78409 21H4.85227L8.31818 15.5455L4.85227 10.0909H6.78409ZM15.7951 13.7273V12.6193L19.119 9.66477C19.4504 9.37121 19.7274 9.10843 19.9499 8.87642C20.1725 8.64441 20.3406 8.41951 20.4542 8.2017C20.5678 7.9839 20.6246 7.75189 20.6246 7.50568C20.6246 7.07954 20.4613 6.741 20.1346 6.49006C19.8079 6.23911 19.4031 6.11364 18.9201 6.11364C18.4087 6.11364 17.9968 6.25095 17.6843 6.52557C17.3718 6.79545 17.2156 7.15057 17.2156 7.59091H15.7383C15.7383 6.78125 16.0389 6.13021 16.6403 5.63778C17.2416 5.14062 18.011 4.89205 18.9485 4.89205C19.5735 4.89205 20.1228 5.00568 20.5962 5.23295C21.0697 5.45549 21.439 5.76326 21.7042 6.15625C21.9693 6.54451 22.1019 6.98485 22.1019 7.47727C22.1019 7.86553 22.0238 8.22538 21.8675 8.55682C21.7113 8.88826 21.4674 9.23153 21.136 9.58665C20.8046 9.94176 20.3784 10.3466 19.8576 10.8011L18.011 12.4205V12.4773H22.3576V13.7273H15.7951Z" fill="black"/>
        </svg>
      </button>
      
      <button class="edit light" title="Clear mark" @click="editor.chain().focus().unsetAllMarks().run()">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="20.049" y1="3.42468" x2="7.54901" y2="25.0753" stroke="black" stroke-width="2"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M14.2982 17.3854C15.1516 17.3331 16.0092 17.2892 16.8711 17.2539C17.3164 17.2539 17.6738 17.4414 17.9434 17.8164C18.5293 18.5781 19.1035 19.3457 19.666 20.1191C20.2402 20.8926 20.8086 21.6777 21.3711 22.4746C21.5352 22.6855 21.7051 22.8496 21.8809 22.9668C22.0684 23.0957 22.2676 23.1602 22.4785 23.1602C22.6309 23.1602 22.7773 23.1309 22.918 23.0723C23.0703 23.0137 23.2285 22.9316 23.3926 22.8262L24.0605 22.3516C24.541 22.0352 24.7812 21.666 24.7812 21.2441C24.7812 20.9629 24.6758 20.6641 24.4648 20.3477L22.584 17.7812C22.4199 17.5234 22.3379 17.2715 22.3379 17.0254C22.3379 16.9551 22.3438 16.8848 22.3555 16.8145C22.3672 16.7441 22.3848 16.6621 22.4082 16.5684L22.7422 15.584C22.7773 15.4902 22.7949 15.3965 22.7949 15.3027C22.8066 15.209 22.8125 15.127 22.8125 15.0566C22.8125 14.7168 22.6953 14.4531 22.4609 14.2656C22.2383 14.0664 21.9219 13.9668 21.5117 13.9668H20.5098C20.2754 13.9668 20.0703 13.9258 19.8945 13.8438C19.7305 13.75 19.5723 13.6152 19.4199 13.4395C18.8403 12.6534 18.3081 11.9335 17.8232 11.28L14.2982 17.3854ZM15.2105 7.8054C15.0987 7.66243 14.9901 7.52483 14.8848 7.39258C14.334 6.70117 13.8359 6.13281 13.3906 5.6875C12.9453 5.24219 12.4941 4.86133 12.0371 4.54492C11.6973 4.32227 11.3516 4.21094 11 4.21094C10.7305 4.21094 10.4551 4.25195 10.1738 4.33398C9.9043 4.4043 9.64648 4.50391 9.40039 4.63281C9.16602 4.75 8.95508 4.88477 8.76758 5.03711C8.58008 5.18945 8.43359 5.33594 8.32812 5.47656C8.08203 5.81641 7.85938 6.19141 7.66016 6.60156C7.47266 7.01172 7.30273 7.42773 7.15039 7.84961C7.00977 8.27148 6.875 8.69922 6.74609 9.13281C6.62891 9.55469 6.51172 9.95312 6.39453 10.3281C6.17188 10.9961 5.96094 11.6699 5.76172 12.3496C5.5625 13.0293 5.36328 13.7031 5.16406 14.3711C5.09375 14.6172 4.98242 14.8105 4.83008 14.9512C4.67773 15.0801 4.4668 15.1621 4.19727 15.1973L3.79297 15.2324C2.99609 15.373 2.58008 15.8652 2.54492 16.709C2.52148 16.9316 2.50977 17.084 2.50977 17.166V17.3594C2.50977 17.7227 2.55664 18.0039 2.65039 18.2031C2.75586 18.4023 2.9082 18.502 3.10742 18.502H3.33594C3.61719 18.502 3.75781 18.6836 3.75781 19.0469C3.75781 19.1172 3.75195 19.1934 3.74023 19.2754C3.72852 19.3457 3.71094 19.4277 3.6875 19.5215C3.61719 19.7559 3.54688 19.9961 3.47656 20.2422C3.41797 20.4883 3.35938 20.7285 3.30078 20.9629C3.27734 21.0566 3.25977 21.1445 3.24805 21.2266C3.23633 21.3086 3.23047 21.3848 3.23047 21.4551C3.23047 21.7949 3.33008 22.0703 3.5293 22.2812C3.74023 22.4922 4.04492 22.6152 4.44336 22.6504L4.98828 22.7207H5.26953C5.99609 22.7207 6.46484 22.334 6.67578 21.5605L7.4668 18.6602C7.5957 18.168 7.91211 17.8984 8.41602 17.8516C8.76724 17.8164 9.11811 17.7828 9.46861 17.7506L11.4222 14.3668C10.8596 14.4119 10.297 14.4719 9.73438 14.5469H9.55859C9.10156 14.5469 8.87305 14.3301 8.87305 13.8965V13.7383C8.87305 13.6914 8.88477 13.6387 8.9082 13.5801C9.13086 12.877 9.34766 12.1914 9.55859 11.5234C9.78125 10.8438 10.0098 10.1582 10.2441 9.4668C10.3613 9.05664 10.5664 8.85156 10.8594 8.85156C10.9648 8.85156 11.0645 8.88672 11.1582 8.95703C11.252 9.02734 11.3574 9.11523 11.4746 9.2207C12.002 9.85352 12.5117 10.4922 13.0039 11.1367C13.0586 11.2054 13.1133 11.2743 13.1679 11.3433L15.2105 7.8054Z" fill="black"/>
        </svg>
      </button>
      <button class="edit light" title="Clear nodes" @click="editor.chain().focus().clearNodes().run()">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="14" cy="6" r="3" stroke="black" stroke-width="2"/>
          <circle cx="6" cy="19" r="3" stroke="black" stroke-width="2"/>
          <line x1="12.4371" y1="8.24282" x2="7.43708" y2="17.2428" stroke="black"/>
          <line x1="15.4642" y1="7.8143" x2="17.4642" y2="12.8143" stroke="black"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M23 18C23 20.2091 21.2091 22 19 22C18.889 22 18.779 21.9955 18.6703 21.9866L16.9987 23.6581C17.6246 23.8795 18.2983 24 19 24C22.3137 24 25 21.3137 25 18C25 17.2983 24.8795 16.6246 24.6581 15.9987L22.9866 17.6703C22.9955 17.779 23 17.889 23 18ZM22.1237 12.8763L20.6465 14.3535C20.1444 14.1264 19.5869 14 19 14C16.7909 14 15 15.7909 15 18C15 18.5869 15.1264 19.1444 15.3535 19.6465L13.8763 21.1237C13.3204 20.2138 13 19.1443 13 18C13 14.6863 15.6863 12 19 12C20.1443 12 21.2138 12.3204 22.1237 12.8763Z" fill="black"/>
          <line x1="25.0502" y1="12.364" x2="13.0502" y2="24.364" stroke="black" stroke-width="2"/>
        </svg>
      </button>
      
      
      <button class="edit light" title="Horisontal rule" @click="editor.chain().focus().setHorizontalRule().run()">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
          <g id="Layer_1">
            <rect x="1" y="15" width="30" height="2"/>
          </g>
        </svg>
      </button>
      <button class="edit light" title="Hard break" @click="editor.chain().focus().setHardBreak().run()">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="21" height="17" viewBox="0 0 21 17" xml:space="preserve">
          <g transform="matrix(1 0 0 1 11 8.9)"  >
            <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"  transform=" translate(-21.11, -21)" d="M 25.3113 29.4 C 24.9963 29.4 24.7863 29.295 24.5763 29.085 L 22.4763 26.985 C 22.3713 26.88 22.2663 26.775 22.2663 26.67 C 22.2663 26.565 22.1613 26.46 22.1613 26.25 C 22.1613 26.145 22.1613 25.935 22.2663 25.83 C 22.2663 25.725 22.3713 25.62 22.4763 25.515 L 24.5763 23.415 C 24.9963 22.995 25.6263 22.995 26.0463 23.415 C 26.4663 23.835 26.4663 24.465 26.0463 24.885 L 25.7313 25.2 H 27.4113 C 27.9363 25.2 28.4613 24.99 28.8813 24.57 C 29.3013 24.15 29.5113 23.625 29.5113 23.1 C 29.5113 22.575 29.3013 22.05 28.8813 21.63 C 28.4613 21.21 27.9363 21 27.4113 21 H 11.6613 C 11.0313 21 10.6113 20.58 10.6113 19.95 C 10.6113 19.32 11.0313 18.9 11.6613 18.9 H 27.4113 C 28.5663 18.9 29.6163 19.32 30.3513 20.16 C 31.1913 21 31.6113 22.05 31.6113 23.1 C 31.6113 24.15 31.1913 25.305 30.3513 26.04 C 29.5113 26.775 28.5663 27.3 27.4113 27.3 H 25.7313 L 26.0463 27.615 C 26.4663 28.035 26.4663 28.665 26.0463 29.085 C 25.8363 29.295 25.6263 29.4 25.3113 29.4 Z M 19.0113 27.3 H 11.6613 C 11.0313 27.3 10.6113 26.88 10.6113 26.25 C 10.6113 25.62 11.0313 25.2 11.6613 25.2 H 19.0113 C 19.6413 25.2 20.0613 25.62 20.0613 26.25 C 20.0613 26.88 19.6413 27.3 19.0113 27.3 Z M 30.5613 14.7 H 11.6613 C 11.0313 14.7 10.6113 14.28 10.6113 13.65 C 10.6113 13.02 11.0313 12.6 11.6613 12.6 H 30.5613 C 31.1913 12.6 31.6113 13.02 31.6113 13.65 C 31.6113 14.28 31.1913 14.7 30.5613 14.7 Z" stroke-linecap="round" />
          </g>
        </svg>
      </button>


      <!-- List Bullet Ordered -->
      <button class="edit light" title="Bullet list" @click="editor.chain().focus().toggleBulletList().run()" :class="{ 'is-active': editor.isActive('bulletList') }">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="10" y1="6" x2="24" y2="6" stroke="black" stroke-width="2"/>
          <circle cx="4" cy="6" r="2" fill="black"/>
          <line x1="10" y1="14" x2="24" y2="14" stroke="black" stroke-width="2"/>
          <circle cx="4" cy="14" r="2" fill="black"/>
          <line x1="10" y1="22" x2="24" y2="22" stroke="black" stroke-width="2"/>
          <circle cx="4" cy="22" r="2" fill="black"/>
        </svg>
      </button>
      <button class="edit light" title="Ordered list" @click="editor.chain().focus().toggleOrderedList().run()" :class="{ 'is-active': editor.isActive('orderedList') }">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="10" y1="6" x2="24" y2="6" stroke="black" stroke-width="2"/>
          <path d="M5.00284 3.18182V9H3.77273V4.34943H3.73864L2.40625 5.18466V4.09375L3.84659 3.18182H5.00284Z" fill="black"/>
          <path d="M2.47159 17V16.1136L4.54261 14.196C4.71875 14.0256 4.86648 13.8722 4.9858 13.7358C5.10701 13.5994 5.19886 13.4659 5.26136 13.3352C5.32386 13.2027 5.35511 13.0597 5.35511 12.9062C5.35511 12.7358 5.31629 12.589 5.23864 12.4659C5.16098 12.3409 5.05492 12.2453 4.92045 12.179C4.78598 12.1108 4.63352 12.0767 4.46307 12.0767C4.28504 12.0767 4.12973 12.1127 3.99716 12.1847C3.86458 12.2566 3.76231 12.3598 3.69034 12.4943C3.61837 12.6288 3.58239 12.7888 3.58239 12.9744H2.41477C2.41477 12.5937 2.50095 12.2633 2.6733 11.983C2.84564 11.7027 3.08712 11.4858 3.39773 11.3324C3.70833 11.179 4.06629 11.1023 4.47159 11.1023C4.88826 11.1023 5.25095 11.1761 5.55966 11.3239C5.87027 11.4697 6.11174 11.6723 6.28409 11.9318C6.45644 12.1913 6.54261 12.4886 6.54261 12.8239C6.54261 13.0436 6.49905 13.2604 6.41193 13.4744C6.3267 13.6884 6.17424 13.9261 5.95455 14.1875C5.73485 14.447 5.42519 14.7585 5.02557 15.1222L4.17614 15.9545V15.9943H6.61932V17H2.47159Z" fill="black"/>
          <path d="M4.62216 25.0795C4.19792 25.0795 3.82008 25.0066 3.48864 24.8608C3.15909 24.7131 2.89867 24.5104 2.70739 24.2528C2.51799 23.9934 2.42045 23.6941 2.41477 23.3551H3.65341C3.66098 23.4972 3.70739 23.6222 3.79261 23.7301C3.87973 23.8362 3.99527 23.9186 4.1392 23.9773C4.28314 24.036 4.44508 24.0653 4.625 24.0653C4.8125 24.0653 4.97822 24.0322 5.12216 23.9659C5.2661 23.8996 5.37879 23.8078 5.46023 23.6903C5.54167 23.5729 5.58239 23.4375 5.58239 23.2841C5.58239 23.1288 5.53883 22.9915 5.4517 22.8722C5.36648 22.7509 5.24337 22.6562 5.08239 22.5881C4.9233 22.5199 4.7339 22.4858 4.5142 22.4858H3.97159V21.5824H4.5142C4.69981 21.5824 4.86364 21.5502 5.00568 21.4858C5.14962 21.4214 5.26136 21.3324 5.34091 21.2188C5.42045 21.1032 5.46023 20.9688 5.46023 20.8153C5.46023 20.6695 5.42519 20.5417 5.35511 20.4318C5.28693 20.3201 5.19034 20.233 5.06534 20.1705C4.94223 20.108 4.7983 20.0767 4.63352 20.0767C4.46686 20.0767 4.31439 20.107 4.17614 20.1676C4.03788 20.2263 3.92708 20.3106 3.84375 20.4205C3.76042 20.5303 3.71591 20.6591 3.71023 20.8068H2.53125C2.53693 20.4716 2.63258 20.1761 2.81818 19.9205C3.00379 19.6648 3.25379 19.465 3.56818 19.321C3.88447 19.1752 4.24148 19.1023 4.6392 19.1023C5.04072 19.1023 5.39205 19.1752 5.69318 19.321C5.99432 19.4669 6.22822 19.6638 6.39489 19.9119C6.56345 20.1581 6.64678 20.4347 6.64489 20.7415C6.64678 21.0672 6.54545 21.339 6.34091 21.5568C6.13826 21.7746 5.87405 21.9129 5.5483 21.9716V22.017C5.97633 22.072 6.30208 22.2206 6.52557 22.4631C6.75095 22.7036 6.86269 23.0047 6.8608 23.3665C6.86269 23.6979 6.76705 23.9924 6.57386 24.25C6.38258 24.5076 6.11837 24.7102 5.78125 24.858C5.44413 25.0057 5.05777 25.0795 4.62216 25.0795Z" fill="black"/>
          <line x1="10" y1="14" x2="24" y2="14" stroke="black" stroke-width="2"/>
          <line x1="10" y1="22" x2="24" y2="22" stroke="black" stroke-width="2"/>
        </svg>
      </button>
      
      <div v-if="isList()">
        <button class="edit light" title="Split item" @click="editor.chain().focus().splitListItem('listItem').run()" :disabled="!editor.can().splitListItem('listItem')">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="2" y1="8" x2="11" y2="8" stroke="black" stroke-width="2"/>
            <line x1="17" y1="8" x2="24" y2="8" stroke="black" stroke-width="2"/>
            <line x1="14" y1="11" x2="14" y2="5" stroke="black" stroke-width="2"/>
            <line x1="14" y1="3" x2="14" y2="1" stroke="black" stroke-width="2"/>
            <line x1="3" y1="10" x2="3" y2="6" stroke="black" stroke-width="2"/>
            <line x1="3" y1="23" x2="3" y2="19" stroke="black" stroke-width="2"/>
            <line x1="14" y1="15" x2="14" y2="13" stroke="black" stroke-width="2"/>
            <line x1="2" y1="21" x2="24" y2="21" stroke="black" stroke-width="2"/>
            <path d="M16 19L20.9517 16.0311L15.9047 13.2273L16 19ZM20.5629 9.75718L17.7483 14.8235L18.6225 15.3091L21.4371 10.2428L20.5629 9.75718Z" fill="black"/>
          </svg>
        </button>
        <button class="edit light" title="Sink item" @click="editor.chain().focus().sinkListItem('listItem').run()" :disabled="!editor.can().sinkListItem('listItem')">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="2" y1="8" x2="24" y2="8" stroke="black" stroke-width="2"/>
            <line x1="14" y1="21" x2="24" y2="21" stroke="black" stroke-width="2"/>
            <line x1="15" y1="23" x2="15" y2="19" stroke="black" stroke-width="2"/>
            <line x1="3" y1="10" x2="3" y2="6" stroke="black" stroke-width="2"/>
            <path d="M11 21L6 18.1132L6 23.8868L11 21ZM2 21.5L6.5 21.5L6.5 20.5L2 20.5L2 21.5Z" fill="black"/>
          </svg>
        </button>
        <button class="edit light" title="Lift item" @click="editor.chain().focus().liftListItem('listItem').run()" :disabled="!editor.can().liftListItem('listItem')">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="2" y1="8" x2="24" y2="8" stroke="black" stroke-width="2"/>
            <line x1="15" y1="21" x2="24" y2="21" stroke="black" stroke-width="2"/>
            <line x1="16" y1="23" x2="16" y2="19" stroke="black" stroke-width="2"/>
            <line x1="3" y1="10" x2="3" y2="6" stroke="black" stroke-width="2"/>
            <path d="M2 21L7 23.8868V18.1132L2 21ZM11 20.5H6.5V21.5H11V20.5Z" fill="black"/>
          </svg>
        </button>
      </div>


      <!-- Block Functions -->
      <button v-if="allFunc" class="edit light" title="Code block" @click="editor.chain().focus().toggleCodeBlock().run()" :class="{ 'is-active': editor.isActive('codeBlock') }">
        <svg version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
          <path d="M27,4H5C3.3,4,2,5.3,2,7v18c0,1.7,1.3,3,3,3h22c1.7,0,3-1.3,3-3V7C30,5.3,28.7,4,27,4z M9.1,7.6c0.1-0.1,0.1-0.2,0.2-0.3
            c0.1-0.1,0.2-0.2,0.3-0.2C10,6.9,10.4,7,10.7,7.3c0.1,0.1,0.2,0.2,0.2,0.3C11,7.7,11,7.9,11,8c0,0.3-0.1,0.5-0.3,0.7
            C10.5,8.9,10.3,9,10,9C9.7,9,9.5,8.9,9.3,8.7C9.1,8.5,9,8.3,9,8C9,7.9,9,7.7,9.1,7.6z M6,8c0-0.3,0.1-0.5,0.3-0.7
            c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1-0.1,0.2-0.1C6.7,7,6.7,7,6.8,7c0.1,0,0.3,0,0.4,0c0.1,0,0.1,0,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1
            c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.2,0.2,0.2,0.3C8,7.7,8,7.9,8,8c0,0.1,0,0.3-0.1,0.4C7.9,8.5,7.8,8.6,7.7,8.7C7.5,8.9,7.3,9,7,9
            S6.5,8.9,6.3,8.7C6.1,8.5,6,8.3,6,8z M11.7,21.3c0.4,0.4,0.4,1,0,1.4C11.5,22.9,11.3,23,11,23s-0.5-0.1-0.7-0.3l-3-3
            c-0.4-0.4-0.4-1,0-1.4l3-3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L9.4,19L11.7,21.3z M12.6,8.9c-0.1-0.1-0.2-0.1-0.3-0.2
            c-0.1-0.1-0.2-0.2-0.2-0.3C12,8.3,12,8.1,12,8c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.1-0.2,0.2-0.3c0.4-0.4,1-0.4,1.4,0
            c0.1,0.1,0.2,0.2,0.2,0.3C14,7.7,14,7.9,14,8c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.3C13.5,8.9,13.3,9,13,9
            C12.9,9,12.7,9,12.6,8.9z M18.9,15.4l-4,8C14.7,23.8,14.4,24,14,24c-0.2,0-0.3,0-0.4-0.1c-0.5-0.2-0.7-0.8-0.4-1.3l4-8
            c0.2-0.5,0.8-0.7,1.3-0.4C18.9,14.4,19.1,15,18.9,15.4z M24.7,19.7l-3,3C21.5,22.9,21.3,23,21,23s-0.5-0.1-0.7-0.3
            c-0.4-0.4-0.4-1,0-1.4l2.3-2.3l-2.3-2.3c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l3,3C25.1,18.7,25.1,19.3,24.7,19.7z"/>
        </svg>
      </button>
      <button v-if="allFunc" class="edit light" title="Block quote" @click="editor.chain().focus().toggleBlockquote().run()" :class="{ 'is-active': editor.isActive('blockquote') }">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="32" height="28" viewBox="0 0 32 28" xml:space="preserve">
          <g transform="matrix(1 0 0 1 17.47 15.39)"  >
            <g style=""   >
              <g transform="matrix(0.61 0 0 0.61 -5.1 -7.62)"  >
                <g style=""   >
                  <g transform="matrix(1 0 0 1 -7 0)"  >
                    <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"  transform=" translate(-9, -16)" d="M 13 11 c 0.6 0 1 -0.4 1 -1 s -0.4 -1 -1 -1 c -5 0 -9 4 -9 9 c 0 2.8 2.2 5 5 5 s 5 -2.2 5 -5 s -2.2 -5 -5 -5 c -0.3 0 -0.7 0 -1 0.1 C 9.3 11.8 11 11 13 11 z" stroke-linecap="round" />
                  </g>
                  <g transform="matrix(1 0 0 1 7 0)"  >
                    <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"  transform=" translate(-23, -16)" d="M 23 13 c -0.3 0 -0.7 0 -1 0.1 c 1.3 -1.3 3 -2.1 5 -2.1 c 0.6 0 1 -0.4 1 -1 s -0.4 -1 -1 -1 c -5 0 -9 4 -9 9 c 0 2.8 2.2 5 5 5 s 5 -2.2 5 -5 S 25.8 13 23 13 z" stroke-linecap="round" />
                  </g>
                </g>
              </g>
              <g transform="matrix(0.61 0 0 0.61 7.71 7.02)"  >
                <g style=""   >
                  <g transform="matrix(1 0 0 1 7 0)"  >
                    <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"  transform=" translate(-23, -16)" d="M 23 9 c -2.8 0 -5 2.2 -5 5 s 2.2 5 5 5 c 0.3 0 0.7 0 1 -0.1 c -1.3 1.3 -3 2.1 -5 2.1 c -0.6 0 -1 0.4 -1 1 s 0.4 1 1 1 c 5 0 9 -4 9 -9 C 28 11.2 25.8 9 23 9 z" stroke-linecap="round" />
                  </g>
                  <g transform="matrix(1 0 0 1 -7 0)"  >
                    <path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"  transform=" translate(-9, -16)" d="M 9 9 c -2.8 0 -5 2.2 -5 5 s 2.2 5 5 5 c 0.3 0 0.7 0 1 -0.1 C 8.7 20.2 7 21 5 21 c -0.6 0 -1 0.4 -1 1 s 0.4 1 1 1 c 5 0 9 -4 9 -9 C 14 11.2 11.8 9 9 9 z" stroke-linecap="round" />
                  </g>
                </g>
              </g>
              <g transform="matrix(0.61 0 0 0.61 -16.47 -1.29)"  >
                <line style="stroke: rgb(0,0,0); stroke-width: 2; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" vector-effect="non-scaling-stroke"  x1="-1.3322676295501878e-15" y1="-22.02271554554524" x2="1.3322676295501878e-15" y2="22.02271554554524" />
              </g>
              <g transform="matrix(0.61 0 0 0.61 2.83 17.38)"  >
                <line style="stroke: rgb(0,0,0); stroke-width: 2; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"  x1="0" y1="0" x2="0" y2="0" />
              </g>
              <g transform="matrix(0.61 0 0 0.61 -2.05 -3.96)"  >
                <line style="stroke: rgb(0,0,0); stroke-width: 2; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"  x1="0" y1="0" x2="0" y2="0" />
              </g>
            </g>
          </g>
        </svg>
      </button>

      <button v-if="allFunc" class="edit light" title="Add image" @click="addImage">
        <svg width="20px" height="16px" viewBox="0 0 20 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 3.8.1 (29687) - http://www.bohemiancoding.com/sketch -->
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Dribbble-Light-Preview" transform="translate(-420.000000, -3881.000000)" fill="#000000">
                    <g id="icons" transform="translate(56.000000, 160.000000)">
                        <path d="M376.083,3725.667 C376.083,3724.562 376.978,3723.667 378.083,3723.667 C379.188,3723.667 380.083,3724.562 380.083,3725.667 C380.083,3726.772 379.188,3727.667 378.083,3727.667 C376.978,3727.667 376.083,3726.772 376.083,3725.667 L376.083,3725.667 Z M382,3733.086 L377.987,3729.074 L377.971,3729.089 L377.955,3729.074 L376.525,3730.504 L371.896,3725.876 L371.881,3725.892 L371.865,3725.876 L366,3731.741 L366,3723 L382,3723 L382,3733.086 Z M364,3737 L384,3737 L384,3721 L364,3721 L364,3737 Z" id="image_picture-[#971]"></path>
                    </g>
                </g>
            </g>
        </svg>
      </button>
      <button v-if="allFunc" v-show="showButton" @click="toggleResize">{{ isDraggable ? 'Dragging' : 'Resizing' }}</button>
      
      <button class="edit light" title="Set link" @click="setLink" :class="{ 'is-active': editor.isActive('link') }">
        <svg xmlns="http://www.w3.org/2000/svg"   viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-link-2">
          <path d="M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"></path>
          <line x1="8" y1="12" x2="16" y2="12"></line>
        </svg>
      </button>
      <button class="edit light" title="Unset link" @click="editor.chain().focus().unsetLink().run()" :disabled="!editor.isActive('link')">
        <svg width="20px" height="18px" viewBox="0 0 20 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Rounded" transform="translate(-102.000000, -1529.000000)">
                    <g id="Content" transform="translate(100.000000, 1428.000000)">
                        <g id="-Round-/-Content-/-link_off" transform="translate(0.000000, 98.000000)">
                            <g>
                                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                                <path d="M21.94,11.23 C21.57,8.76 19.32,7 16.82,7 L13.95,7 C13.43,7 13,7.43 13,7.95 C13,8.47 13.43,8.9 13.95,8.9 L16.85,8.9 C18.45,8.9 19.89,10.04 20.07,11.63 C20.24,13.06 19.43,14.32 18.22,14.85 L19.62,16.25 C21.25,15.23 22.26,13.34 21.94,11.23 Z M4.12,3.56 C3.73,3.17 3.1,3.17 2.71,3.56 C2.32,3.95 2.32,4.58 2.71,4.97 L5.11,7.37 C3.17,8.17 1.84,10.14 2.02,12.41 C2.23,15.05 4.59,17 7.23,17 L10.05,17 C10.57,17 11,16.57 11,16.05 C11,15.53 10.57,15.1 10.05,15.1 L7.16,15.1 C5.53,15.1 4.06,13.91 3.91,12.28 C3.76,10.56 5.02,9.11 6.66,8.93 L8.76,11.03 C8.33,11.12 8,11.49 8,11.95 L8,12.05 C8,12.57 8.43,13 8.95,13 L10.73,13 L13,15.27 L13,17 L14.73,17 L18.03,20.3 C18.42,20.69 19.05,20.69 19.44,20.3 C19.83,19.91 19.83,19.28 19.44,18.89 L4.12,3.56 Z M16,11.95 C16,11.43 15.57,11 15.05,11 L14.39,11 L15.88,12.49 C15.95,12.36 16,12.21 16,12.05 L16,11.95 Z" id="🔹Icon-Color" fill="#1D1D1D"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
      </button>
      <button v-if="allFunc" class="edit light" title="Link preview" @click="setLinkPreviewBlock" :class="{ 'is-active': editor.isActive('LinkPreviewBlock') }">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_sTB)">
          <line x1="12" y1="8" x2="24" y2="8" stroke="black" stroke-width="2"/>
          <line x1="12" y1="13" x2="24" y2="13" stroke="black" stroke-width="2"/>
          <line x1="7.94975" y1="8.70711" x2="2.2929" y2="3.05025" stroke="black" stroke-width="2"/>
          <line x1="2.29289" y1="12.9498" x2="7.94975" y2="7.2929" stroke="black" stroke-width="2"/>
          <line x1="17.2929" y1="23.9498" x2="22.9497" y2="18.2929" stroke="black" stroke-width="2"/>
          <line x1="13.0502" y1="18.2929" x2="18.7071" y2="23.9497" stroke="black" stroke-width="2"/>
          </g>
          <defs>
          <clipPath id="clip0_sTB">
          <rect width="28" height="28" fill="white"/>
          </clipPath>
          </defs>
        </svg>
      </button>

      <button v-if="allFunc" class="edit light" title="Add iFrame" @click="setIframe" :class="{ 'is-active': editor.isActive('iframe') }">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
          <g id="Layer_1">
            <polygon points="3,3 6,3 6,1 1,1 1,6 3,6 	"/>
            <polygon points="44,3 47,3 47,6 49,6 49,1 44,1 	"/>
            <rect x="9" y="1" width="4" height="2"/>
            <rect x="16" y="1" width="4" height="2"/>
            <rect x="23" y="1" width="4" height="2"/>
            <rect x="30" y="1" width="4" height="2"/>
            <rect x="37" y="1" width="4" height="2"/>
            <rect x="9" y="47" width="4" height="2"/>
            <rect x="16" y="47" width="4" height="2"/>
            <rect x="23" y="47" width="4" height="2"/>
            <rect x="30" y="47" width="4" height="2"/>
            <rect x="37" y="47" width="4" height="2"/>
            <polygon points="47,47 44,47 44,49 49,49 49,44 47,44 	"/>
            <rect x="47" y="9" width="2" height="4"/>
            <rect x="47" y="16" width="2" height="4"/>
            <rect x="47" y="23" width="2" height="4"/>
            <rect x="47" y="30" width="2" height="4"/>
            <rect x="47" y="37" width="2" height="4"/>
            <polygon points="6,47 3,47 3,44 1,44 1,49 6,49 	"/>
            <rect x="1" y="9" width="2" height="4"/>
            <rect x="1" y="16" width="2" height="4"/>
            <rect x="1" y="23" width="2" height="4"/>
            <rect x="1" y="30" width="2" height="4"/>
            <rect x="1" y="37" width="2" height="4"/>
          </g>
        </svg>
      </button>
      <button v-if="allFunc" class="edit light" title="YouTube" @click="setYoutube" :class="{ 'is-active': editor.isActive('youtube') }">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M26.4764 11.6588C26.4671 11.145 26.4264 10.4953 26.3553 9.71033C26.2837 8.92493 26.1814 8.22303 26.0483 7.60458C25.896 6.90993 25.5652 6.32458 25.0562 5.84873C24.5471 5.37278 23.9546 5.09688 23.2787 5.02063C21.1658 4.78288 17.973 4.66388 13.7001 4.66388C9.42713 4.66388 6.23423 4.78288 4.12148 5.02063C3.44568 5.09683 2.85553 5.37278 2.35128 5.84873C1.84683 6.32443 1.51848 6.90978 1.36618 7.60458C1.22358 8.22323 1.11638 8.92508 1.04503 9.71033C0.973785 10.4953 0.933285 11.1447 0.923835 11.6588C0.914185 12.1727 0.909485 12.8864 0.909485 13.8001C0.909485 14.7137 0.914185 15.4276 0.923885 15.9414C0.933335 16.4556 0.973835 17.105 1.04508 17.8899C1.11643 18.6752 1.21878 19.3771 1.35203 19.9957C1.50433 20.6905 1.83498 21.2758 2.34413 21.7514C2.85338 22.2273 3.44593 22.5032 4.12153 22.5794C6.23428 22.8174 9.42699 22.9364 13.7001 22.9364C17.9734 22.9364 21.1659 22.8174 23.2788 22.5794C23.9547 22.5033 24.5446 22.2273 25.049 21.7514C25.5535 21.2757 25.8816 20.6902 26.0339 19.9957C26.1766 19.3771 26.2837 18.6752 26.3553 17.8899C26.4264 17.105 26.4668 16.4553 26.4764 15.9414C26.486 15.4276 26.4908 14.7137 26.4908 13.8001C26.4908 12.8864 26.486 12.1727 26.4764 11.6588ZM18.7536 14.571L11.4448 19.139C11.3115 19.2341 11.1495 19.2817 10.9593 19.2817C10.8166 19.2817 10.6691 19.2435 10.5169 19.1674C10.2029 18.9963 10.0459 18.7297 10.0459 18.3681V9.23218C10.0459 8.87073 10.2029 8.60413 10.5169 8.43288C10.8405 8.26133 11.1497 8.27093 11.4448 8.46143L18.7537 13.0294C19.0391 13.1909 19.1818 13.448 19.1818 13.8002C19.1818 14.1522 19.039 14.4094 18.7536 14.571Z" fill="black"/>
        </svg>
      </button>
      <button v-if="allFunc" class="edit light" title="Telegram" @click="setTelegram" :class="{ 'is-active': editor.isActive('telegram') }">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.25652 15.4552C7.25652 15.4552 3.83394 14.3817 1.77868 13.748C-0.0928525 13.0339 1.61118 12.1553 2.42042 11.8713C3.22965 11.5875 22.3051 4.19527 23.2184 3.8448C24.1721 3.40236 25.3398 3.80745 24.7938 5.83518C24.3227 8.01238 21.5754 21.0783 21.1849 22.7787C20.7944 24.479 19.2168 23.5088 19.2168 23.5088L10.3392 16.9537L7.25652 15.4552Z" stroke="black"/>
          <path d="M9.97144 22.5763C9.97144 22.5763 10.4297 22.636 10.9135 22.1813C11.3974 21.7268 13.7197 19.4498 13.7197 19.4498" stroke="black"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.25896 15.4566L10.3446 16.959L9.97248 22.5762C9.97248 22.5762 9.44672 22.6661 9.30568 22.1907C9.16453 21.7154 7.25885 15.4565 7.25885 15.4565L7.25896 15.4566Z" fill="black" stroke="black" stroke-linejoin="bevel"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.25885 15.4565C7.25885 15.4565 20.8763 7.19343 20.0711 7.86685C19.2656 8.54027 10.3445 16.9589 10.3445 16.9589L7.25885 15.4565Z" fill="black" stroke="black" stroke-linejoin="bevel"/>
        </svg>
      </button>
      <button v-if="allFunc" class="edit light" title="Twitter" @click="setTwitter" :class="{ 'is-active': editor.isActive('twitter') }">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.8625 23.9997C18.2962 23.9997 23.4563 16.3042 23.4563 9.63146C23.4563 9.4124 23.4562 9.19498 23.4412 8.97838C24.445 8.26458 25.3113 7.37832 26 6.36425C25.065 6.77283 24.0712 7.04079 23.055 7.15892C24.125 6.52759 24.9262 5.53572 25.31 4.36534C24.3025 4.95361 23.2012 5.36878 22.0525 5.59154C20.11 3.55845 16.8613 3.45995 14.795 5.37242C13.4638 6.60556 12.8975 8.44415 13.3112 10.1979C9.1875 9.99358 5.345 8.07621 2.74 4.92198C1.37875 7.2295 2.075 10.1804 4.32875 11.6621C3.5125 11.6387 2.71375 11.4223 2 11.031V11.0951C2.00125 13.4986 3.7225 15.5682 6.115 16.0444C5.36 16.2475 4.5675 16.2769 3.8 16.1305C4.47125 18.1882 6.3975 19.5976 8.59125 19.6382C6.775 21.0436 4.53125 21.8068 2.22125 21.8043C1.81375 21.8031 1.40625 21.7797 1 21.7317C3.34625 23.2134 6.075 23.9998 8.8625 23.9961" fill="black"/>
        </svg>
      </button>
      <button v-if="allFunc" class="edit light" title="Instagram" @click="setInstagram" :class="{ 'is-active': editor.isActive('instagram') }">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M25.1932 19.8248V19.3248H25.193V8.17502C25.193 5.21463 22.7852 2.80683 19.8247 2.80683H8.17486C5.21447 2.80683 2.80683 5.21467 2.80683 8.17502V19.8248C2.80683 22.7853 5.21446 25.1932 8.17486 25.193H19.8248C22.7853 25.193 25.1932 22.7854 25.1932 19.8248ZM8.17486 1.5H19.8247C23.5051 1.5 26.5 4.49496 26.4998 8.175V19.8248C26.4998 23.5049 23.5051 26.4998 19.8247 26.4998H8.17486C4.4948 26.4998 1.5 23.5051 1.5 19.8248V8.17502C1.5 4.49493 4.4948 1.5 8.17486 1.5Z" fill="black" stroke="black"/>
          <path d="M7.80042 14.0002C7.80042 10.5822 10.5819 7.80072 13.9999 7.80072C17.4179 7.80072 20.1994 10.5822 20.1994 14.0002C20.1994 17.4181 17.418 20.1994 13.9999 20.1994C10.5819 20.1994 7.80042 17.4181 7.80042 14.0002ZM9.10725 14.0001C9.10725 16.6983 11.3018 18.8924 13.9999 18.8924C16.698 18.8924 18.8926 16.6983 18.8926 14.0001C18.8926 11.3018 16.6982 9.1074 13.9999 9.1074C11.3016 9.1074 9.10725 11.3018 9.10725 14.0001Z" fill="black" stroke="black"/>
          <path d="M20.9804 5.34467C20.5359 5.34467 20.0993 5.5246 19.7854 5.83987C19.47 6.15359 19.2887 6.59035 19.2887 7.03634C19.2887 7.48095 19.4702 7.91755 19.7854 8.23282C20.0992 8.54655 20.5359 8.72802 20.9804 8.72802C21.4264 8.72802 21.8616 8.54655 22.1769 8.23282C22.4921 7.91755 22.6721 7.48079 22.6721 7.03634C22.6721 6.59035 22.4921 6.15359 22.1769 5.83987C21.8631 5.5246 21.4264 5.34467 20.9804 5.34467Z" fill="black"/>
        </svg>
      </button>
      <button v-if="allFunc" class="edit light" title="Tree block" @click="setTreeBlock" :class="{ 'is-active': editor.isActive('TreeBlock') }">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_sTB)">
          <line x1="12" y1="8" x2="24" y2="8" stroke="black" stroke-width="2"/>
          <line x1="12" y1="13" x2="24" y2="13" stroke="black" stroke-width="2"/>
          <line x1="7.94975" y1="8.70711" x2="2.2929" y2="3.05025" stroke="black" stroke-width="2"/>
          <line x1="2.29289" y1="12.9498" x2="7.94975" y2="7.2929" stroke="black" stroke-width="2"/>
          <line x1="17.2929" y1="23.9498" x2="22.9497" y2="18.2929" stroke="black" stroke-width="2"/>
          <line x1="13.0502" y1="18.2929" x2="18.7071" y2="23.9497" stroke="black" stroke-width="2"/>
          </g>
          <defs>
          <clipPath id="clip0_sTB">
          <rect width="28" height="28" fill="white"/>
          </clipPath>
          </defs>
        </svg>
      </button>
      <button v-if="allFunc" class="edit light" title="Table of contents" @click="setTocBlock" :class="{ 'is-active': editor.isActive('TocBlock') }">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="2" y1="6" x2="16" y2="6" stroke="black" stroke-width="2"/>
          <line x1="2" y1="14" x2="16" y2="14" stroke="black" stroke-width="2"/>
          <line x1="2" y1="22" x2="16" y2="22" stroke="black" stroke-width="2"/>
          <line x1="21" y1="6" x2="24" y2="6" stroke="black" stroke-width="2"/>
          <line x1="21" y1="14" x2="24" y2="14" stroke="black" stroke-width="2"/>
          <line x1="21" y1="22" x2="24" y2="22" stroke="black" stroke-width="2"/>
        </svg>
      </button>

      <button class="edit light" title="Task list" @click="editor.chain().focus().toggleTaskList().run()" :class="{ 'is-active': editor.isActive('taskList') }">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="12" y1="8" x2="24" y2="8" stroke="black" stroke-width="2"/>
          <line x1="12" y1="21" x2="24" y2="21" stroke="black" stroke-width="2"/>
          <rect x="2.5" y="4.5" width="7" height="7" stroke="black"/>
          <rect x="2.5" y="17.5" width="7" height="7" stroke="black"/>
          <line x1="3.44721" y1="5.77639" x2="5.44721" y2="9.77639" stroke="black"/>
          <line x1="5.56588" y1="9.75193" x2="9.56588" y2="2.75193" stroke="black"/>
        </svg>
      </button>
      <div v-if="isTask()">
        <button class="edit light" title="Split task" @click="editor.chain().focus().splitListItem('taskItem').run()" :disabled="!editor.can().splitListItem('taskItem')">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="9" y1="8" x2="13" y2="8" stroke="black" stroke-width="2"/>
            <line x1="19" y1="8" x2="24" y2="8" stroke="black" stroke-width="2"/>
            <line x1="16" y1="11" x2="16" y2="5" stroke="black" stroke-width="2"/>
            <line x1="16" y1="3" x2="16" y2="1" stroke="black" stroke-width="2"/>
            <line x1="16" y1="15" x2="16" y2="13" stroke="black" stroke-width="2"/>
            <line x1="12" y1="21" x2="24" y2="21" stroke="black" stroke-width="2"/>
            <path d="M18 19L22.9517 16.0311L17.9047 13.2273L18 19ZM22.5629 9.75718L19.7483 14.8235L20.6225 15.3091L23.4371 10.2428L22.5629 9.75718Z" fill="black"/>
            <rect x="2.5" y="4.5" width="7" height="7" stroke="black"/>
            <rect x="2.5" y="17.5" width="7" height="7" stroke="black"/>
          </svg>
        </button>
        <button class="edit light" title="Sink task" @click="editor.chain().focus().sinkListItem('taskItem').run()" :disabled="!editor.can().sinkListItem('taskItem')">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="12" y1="8" x2="24" y2="8" stroke="black" stroke-width="2"/>
            <line x1="20" y1="21" x2="24" y2="21" stroke="black" stroke-width="2"/>
            <path d="M11 21L6 18.1132V23.8868L11 21ZM2 21.5H6.5V20.5H2V21.5Z" fill="black"/>
            <rect x="2.5" y="4.5" width="7" height="7" stroke="black"/>
            <rect x="13.5" y="17.5" width="7" height="7" stroke="black"/>
          </svg>
        </button>
        <button class="edit light" title="Lift task" @click="editor.chain().focus().liftListItem('taskItem').run()" :disabled="!editor.can().liftListItem('taskItem')">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="12" y1="8" x2="24" y2="8" stroke="black" stroke-width="2"/>
            <line x1="20" y1="21" x2="24" y2="21" stroke="black" stroke-width="2"/>
            <path d="M2 21L7 23.8868L7 18.1132L2 21ZM11 20.5L6.5 20.5L6.5 21.5L11 21.5L11 20.5Z" fill="black"/>
            <rect x="2.5" y="4.5" width="7" height="7" stroke="black"/>
            <rect x="13.5" y="17.5" width="7" height="7" stroke="black"/>
          </svg>
        </button>

      </div>

      <button v-if="allFunc" class="edit light" title="Add table" @click="editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run()" :class="{ 'is-active': editor.isActive('table')}">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M25 10H3V24H25V10Z" stroke="black" stroke-width="2"/>
          <path d="M10 9V25" stroke="black" stroke-width="2"/>
          <path d="M18 9V25" stroke="black" stroke-width="2"/>
          <line x1="2" y1="17" x2="26" y2="17" stroke="black" stroke-width="2"/>
          <rect x="2" y="3" width="24" height="8" fill="black"/>
        </svg>
      </button>

      <div v-if="allFunc && isTable()" class="flex-container">
        <button class="edit light" title="Delete table" @click="editor.chain().focus().deleteTable().run()">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_dT)">
              <path d="M25 10H3V24H25V10Z" stroke="black" stroke-width="2"/>
              <path d="M10 9V25" stroke="black" stroke-width="2"/>
              <path d="M18 9V25" stroke="black" stroke-width="2"/>
              <line x1="2" y1="17" x2="26" y2="17" stroke="black" stroke-width="2"/>
              <rect x="2" y="3" width="24" height="8" fill="black"/>
              <line x1="10.4645" y1="3.46446" x2="17.5356" y2="10.5355" stroke="#F5F5F5" stroke-width="2"/>
              <line x1="17.5355" y1="3.46449" x2="10.4645" y2="10.5356" stroke="#F5F5F5" stroke-width="2"/>
            </g>
            <defs>
              <clipPath id="clip0_dT">
                <rect width="28" height="28" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </button>

        <button class="edit light" title="Add column before" @click="editor.chain().focus().addColumnBefore().run()">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="28" height="28" fill="#F5F5F5"/>
            <path d="M10 25L10 3L3 3L3 25L10 25Z" stroke="black" stroke-width="2"/>
            <path d="M9 10L4 10" stroke="black" stroke-width="2"/>
            <path d="M9 18L4 18" stroke="black" stroke-width="2"/>
            <path d="M25 14L13 14" stroke="black" stroke-width="2"/>
            <path d="M19 20L19 8" stroke="black" stroke-width="2"/>
          </svg>
        </button>
        <button class="edit light" title="Add column after" @click="editor.chain().focus().addColumnAfter().run()">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="28" height="28" fill="#F5F5F5"/>
            <path d="M18 3L18 25L25 25L25 3L18 3Z" stroke="black" stroke-width="2"/>
            <path d="M19 18L24 18" stroke="black" stroke-width="2"/>
            <path d="M19 10L24 10" stroke="black" stroke-width="2"/>
            <path d="M3 14L15 14" stroke="black" stroke-width="2"/>
            <path d="M9 8L9 20" stroke="black" stroke-width="2"/>
          </svg>
        </button>
        <button class="edit light" title="Delete column" @click="editor.chain().focus().deleteColumn().run()">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_dC)">
              <path d="M18 25L18 3L10 3L10 25L18 25Z" stroke="black" stroke-width="2"/>
              <path d="M19 10L9 10" stroke="black" stroke-width="2"/>
              <path d="M19 18L9 18" stroke="black" stroke-width="2"/>
              <path d="M22.4853 5.51471L5.51473 22.4853" stroke="black" stroke-width="2"/>
              <path d="M22.4853 22.4853L5.51471 5.51471" stroke="black" stroke-width="2"/>
              </g>
            <defs>
              <clipPath id="clip0_dC">
                <rect width="28" height="28" fill="white" transform="translate(28) rotate(90)"/>
              </clipPath>
            </defs>
          </svg>
        </button>
        <button class="edit light" title="Add row before" @click="editor.chain().focus().addRowBefore().run()">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 10L25 10L25 3L3 3L3 10Z" stroke="black" stroke-width="2"/>
            <path d="M18 9L18 4" stroke="black" stroke-width="2"/>
            <path d="M10 9L10 4" stroke="black" stroke-width="2"/>
            <path d="M14 25L14 13" stroke="black" stroke-width="2"/>
            <path d="M8 19L20 19" stroke="black" stroke-width="2"/>
          </svg>
        </button>
        <button class="edit light" title="Add row after" @click="editor.chain().focus().addRowAfter().run()">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25 18H3V25H25V18Z" stroke="black" stroke-width="2"/>
            <path d="M10 19V24" stroke="black" stroke-width="2"/>
            <path d="M18 19V24" stroke="black" stroke-width="2"/>
            <path d="M14 3V15" stroke="black" stroke-width="2"/>
            <path d="M20 9H8" stroke="black" stroke-width="2"/>
          </svg>
        </button>
        <button class="edit light" title="Delete row" @click="editor.chain().focus().deleteRow().run()">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_dR)">
            <path d="M25 10H3V18H25V10Z" stroke="black" stroke-width="2"/>
            <path d="M10 9V19" stroke="black" stroke-width="2"/>
            <path d="M18 9V19" stroke="black" stroke-width="2"/>
            <path d="M5.51471 5.51471L22.4853 22.4853" stroke="black" stroke-width="2"/>
            <path d="M22.4853 5.51473L5.51471 22.4853" stroke="black" stroke-width="2"/>
            </g>
            <defs>
            <clipPath id="clip0_dR">
            <rect width="28" height="28" fill="white"/>
            </clipPath>
            </defs>
          </svg>
        </button>
        <button class="edit light" title="Merge cells" @click="editor.chain().focus().mergeCells().run()">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25 3H3V25H25V3Z" stroke="black" stroke-width="2"/>
            <path d="M14 18V26" stroke="black" stroke-width="2"/>
            <path d="M14 2V10" stroke="black" stroke-width="2"/>
            <line x1="2" y1="19" x2="26" y2="19" stroke="black" stroke-width="2"/>
            <line x1="2" y1="9" x2="26" y2="9" stroke="black" stroke-width="2"/>
            <path d="M5 14L10 16.8868V11.1132L5 14ZM23 14L18 11.1132V16.8868L23 14ZM9.5 14.5L18.5 14.5V13.5L9.5 13.5V14.5Z" fill="black"/>
          </svg>
        </button>
        <button class="edit light" title="Split cell" @click="editor.chain().focus().splitCell().run()">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25 3H3V25H25V3Z" stroke="black" stroke-width="2"/>
            <path d="M14 18V26" stroke="black" stroke-width="2"/>
            <path d="M14 2V10" stroke="black" stroke-width="2"/>
            <line x1="2" y1="19" x2="26" y2="19" stroke="black" stroke-width="2"/>
            <line x1="2" y1="9" x2="26" y2="9" stroke="black" stroke-width="2"/>
            <line x1="14" y1="12" x2="14" y2="16" stroke="black" stroke-width="2"/>
          </svg>
        </button>
        <button class="edit light" title="Toggle header column" @click="editor.chain().focus().toggleHeaderColumn().run()">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="10" y="25" width="23" height="8" transform="rotate(-90 10 25)" stroke="black" stroke-dasharray="2 2"/>
            <rect x="12" y="23" width="19" height="4" transform="rotate(-90 12 23)" fill="black" stroke="black" stroke-dasharray="2 2"/>
            <path d="M11.5 17.1364L16.5 17.1364" stroke="#F5F5F5" stroke-width="2"/>
            <path d="M11.5 9.86365L16.5 9.86365" stroke="#F5F5F5" stroke-width="2"/>
          </svg>
        </button>
        <button class="edit light" title="Toggle header row" @click="editor.chain().focus().toggleHeaderRow().run()">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2.5" y="9.5" width="23" height="8" stroke="black" stroke-dasharray="2 2"/>
            <rect x="4.5" y="11.5" width="19" height="4" fill="black" stroke="black" stroke-dasharray="2 2"/>
            <path d="M10.3636 11V16" stroke="#F5F5F5" stroke-width="2"/>
            <path d="M17.6364 11V16" stroke="#F5F5F5" stroke-width="2"/>
          </svg>
        </button>
        <button class="edit light" title="Toggle header cell" @click="editor.chain().focus().toggleHeaderCell().run()">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="7.5" y="19.5" width="12" height="12" transform="rotate(-90 7.5 19.5)" stroke="black" stroke-dasharray="2 2"/>
            <rect x="10.5" y="16.5" width="6" height="6" transform="rotate(-90 10.5 16.5)" fill="black" stroke="black" stroke-dasharray="2 2"/>
            <line x1="2" y1="9.5" x2="6" y2="9.5" stroke="black"/>
            <line x1="21" y1="9.5" x2="25" y2="9.5" stroke="black"/>
            <line x1="17.5" y1="6" x2="17.5" y2="2" stroke="black"/>
            <line x1="10.5" y1="6" x2="10.5" y2="2" stroke="black"/>
            <line x1="9.5" y1="25" x2="9.5" y2="21" stroke="black"/>
            <line x1="17.5" y1="25" x2="17.5" y2="21" stroke="black"/>
            <line x1="21" y1="17.5" x2="25" y2="17.5" stroke="black"/>
            <line x1="2" y1="17.5" x2="6" y2="17.5" stroke="black"/>
          </svg>
        </button>

        <input title="Cell background color"
          type="color"
          @input="this.editor.chain().focus().setCellAttribute('backgroundColor', $event.target.value).run()"
          :value="editor.getAttributes('textStyle').backgroundColor"
          id="cell_backgroundcolor"
        >

        <button class="edit light" title="Merge or split" @click="editor.chain().focus().mergeOrSplit().run()">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25 3H3V25H25V3Z" stroke="black" stroke-width="2"/>
            <path d="M14 18V26" stroke="black" stroke-width="2"/>
            <path d="M14 2V10" stroke="black" stroke-width="2"/>
            <path d="M14 12V16" stroke="black" stroke-width="2"/>
            <line x1="2" y1="19" x2="26" y2="19" stroke="black" stroke-width="2"/>
            <line x1="2" y1="9" x2="26" y2="9" stroke="black" stroke-width="2"/>
            <path d="M23 14L18 11.1132V16.8868L23 14ZM17 14.5H18.5V13.5H17V14.5Z" fill="black"/>
            <path d="M5 14L10 16.8868V11.1132L5 14ZM11 13.5H9.5V14.5H11V13.5Z" fill="black"/>
          </svg>
        </button>
        <button class="edit light" title="Set cell attribute" @click="editor.chain().focus().setCellAttribute('colspan', 2).run()">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25 3H3V25H25V3Z" stroke="black" stroke-width="2"/>
            <path d="M14 22V26" stroke="black" stroke-width="2"/>
            <path d="M14 15V19" stroke="black" stroke-width="2"/>
            <path d="M14 8V12" stroke="black" stroke-width="2"/>
            <line x1="2" y1="9" x2="26" y2="9" stroke="black" stroke-width="2"/>
            <line x1="2" y1="17" x2="11" y2="17" stroke="black" stroke-width="2"/>
            <line x1="17" y1="17" x2="26" y2="17" stroke="black" stroke-width="2"/>
          </svg>
        </button>
        <button class="edit light" title="Inspect tables" @click="editor.chain().focus().fixTables().run()">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 11V25" stroke="black" stroke-width="2"/>
            <path d="M18 9V25" stroke="black" stroke-width="2"/>
            <line x1="2" y1="17" x2="26" y2="17" stroke="black" stroke-width="2"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.53513 9H3H2V10V24V25H3H25H26V24V10V9H25H12.4649C11.7733 10.1956 10.4806 11 9 11C7.51944 11 6.22675 10.1956 5.53513 9ZM9 11H4V23H24V11H9Z" fill="black"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2 3H9C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11H2V3ZM12.874 8C12.4299 9.72523 10.8638 11 9 11H26V3H9C10.8638 3 12.4299 4.27477 12.874 6H22V8H12.874Z" fill="black"/>
            <line x1="6.41603" y1="6.72265" x2="8.41603" y2="9.72265" stroke="black"/>
            <line x1="7.60957" y1="9.68765" x2="11.6096" y2="4.68765" stroke="black"/>
          </svg>
        </button>
        <button class="edit light" title="Next cell" @click="editor.chain().focus().goToNextCell().run()">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="3" y1="7.5" x2="6" y2="7.5" stroke="black"/>
            <line x1="19" y1="7.5" x2="24" y2="7.5" stroke="black"/>
            <line x1="18.5" y1="7" x2="18.5" y2="4" stroke="black"/>
            <line x1="6.5" y1="7" x2="6.5" y2="4" stroke="black"/>
            <line x1="6.5" y1="25" x2="6.5" y2="20" stroke="black"/>
            <line x1="18.5" y1="25" x2="18.5" y2="20" stroke="black"/>
            <line x1="19" y1="19.5" x2="24" y2="19.5" stroke="black"/>
            <line x1="3" y1="19.5" x2="6" y2="19.5" stroke="black"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14 12H20H21H22V11H21H14H13V12V15V16H14H21H22V15H21H20H14V12Z" fill="black"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M25.2559 12.8249L26 13.5L25.2559 14.1751L21.75 17.3559L20.75 18.2632V16.9129V15H21.75V16.0057L24.5118 13.5L21.75 10.9944V12H20.75V10.0871V8.73688L21.75 9.64414L25.2559 12.8249Z" fill="black"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 18L8 9L17 9L17 12H19L19 9V7H17H8H6V9V18V20H8L17 20H19L19 18L19 15H17L17 18L8 18Z" fill="black"/>
          </svg>
        </button>
        <button class="edit light" title="Prev cell" @click="editor.chain().focus().goToPreviousCell().run()">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="26" y1="20.5" x2="23" y2="20.5" stroke="black"/>
            <line x1="10" y1="20.5" x2="5" y2="20.5" stroke="black"/>
            <line x1="10.5" y1="21" x2="10.5" y2="24" stroke="black"/>
            <line x1="22.5" y1="21" x2="22.5" y2="24" stroke="black"/>
            <line x1="22.5" y1="3" x2="22.5" y2="8" stroke="black"/>
            <line x1="10.5" y1="3" x2="10.5" y2="8" stroke="black"/>
            <line x1="10" y1="8.5" x2="5" y2="8.5" stroke="black"/>
            <line x1="26" y1="8.5" x2="23" y2="8.5" stroke="black"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15 16L9 16L8 16L7 16L7 17L8 17L15 17L16 17L16 16L16 13L16 12L15 12L8 12L7 12L7 13L8 13L9 13L15 13L15 16Z" fill="black"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.74412 15.1751L3 14.5L3.74412 13.8249L7.25 10.6441L8.25 9.73684L8.25 11.0871L8.25 13L7.25 13L7.25 11.9943L4.48825 14.5L7.25 17.0056L7.25 16L8.25 16L8.25 17.9129L8.25 19.2631L7.25 18.3559L3.74412 15.1751Z" fill="black"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M21 10L21 19L12 19L12 16L10 16L10 19L10 21L12 21L21 21L23 21L23 19L23 10L23 8L21 8L12 8L10 8L10 10L10 13L12 13L12 10L21 10Z" fill="black"/>
          </svg>
        </button>

      </div>

    </div>

    <div v-if="edit">
      <PasteFromClipboard v-if="allFunc" :elId="elId" :prfx="prfx"/>
    </div>

  </div>

  <!-- Bubble Menu editor -->
<!--
  <bubble-menu :editor="editor" :tippy-options="{ duration: 100 }" v-if="edit"
  >
  <button @click="editor.chain().focus().toggleBold().run()" :class="{ 'is-active': editor.isActive('bold') }">
      Bold
    </button>
    <button @click="editor.chain().focus().toggleItalic().run()" :class="{ 'is-active': editor.isActive('italic') }">
      Italic
    </button>
    <button @click="editor.chain().focus().toggleHighlight().run()" :class="{ 'is-active': editor.isActive('highlight') }">
      Highlight
    </button>
    <button @click="editor.chain().focus().toggleUnderline().run()" :class="{ 'is-active': editor.isActive('underline') }">
      Underline
    </button>
    <button @click="editor.chain().focus().toggleStrike().run()" :class="{ 'is-active': editor.isActive('strike') }">
      Strike
    </button>
    <button @click="editor.chain().focus().toggleCode().run()" :class="{ 'is-active': editor.isActive('code') }">
      Code
    </button>
    <button @click="editor.chain().focus().toggleSubscript().run()" :class="{ 'is-active': editor.isActive('subscript') }">
      Subscript
    </button>
    <button @click="editor.chain().focus().toggleSuperscript().run()" :class="{ 'is-active': editor.isActive('superscript') }">
      Superscript
    </button>
    
    <button @click="editor.chain().focus().unsetAllMarks().run()">
      clear marks
    </button>
  </bubble-menu>

-->  

  <!-- Floating Menu editor-->
<!--
  <floating-menu :editor="editor" :tippy-options="{ duration: 100 }" v-if="edit">
    <button @click="editor.chain().focus().toggleHeading({ level: 2 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 2 }) }">
      h2
    </button>
    <button @click="editor.chain().focus().toggleHeading({ level: 3 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 3 }) }">
      h3
    </button>
    <button @click="editor.chain().focus().toggleBulletList().run()" :class="{ 'is-active': editor.isActive('bulletList') }">
      BulletList
    </button>
    <button @click="editor.chain().focus().toggleOrderedList().run()" :class="{ 'is-active': editor.isActive('orderedList') }">
      OrderedList
    </button>
    <button @click="editor.chain().focus().toggleCodeBlock().run()" :class="{ 'is-active': editor.isActive('codeBlock') }">
      code block
    </button>
    <button @click="editor.chain().focus().toggleBlockquote().run()" :class="{ 'is-active': editor.isActive('blockquote') }">
      blockquote
    </button>
  </floating-menu>

-->  

  <!-- Editor  view -->
  <div v-if="edit">
    <editor-content :editor="editor" class="content-edit" v-show="isWView === true" :style="{ 'min-height': viewContentHeight}"/>
  </div>
  <div v-else>
    <editor-content :editor="editor" class="content-view" v-show="isWView === true"
        />
  </div>

  <div class="field" v-if="isHView === true">
    <label>Html text:</label><span>&nbsp;&nbsp;&nbsp;&nbsp;(Characters with spaces:&nbsp; {{ textHTML.svl.length }})</span>
    <textarea v-model="textHTML.svl" type="text" placeholder="Enter a html text ..." rows="27" style="width: 95%; font-family: Helvetica, Arial, sans-serif; line-height: 1.4; font-size: 16px;"/>
  </div>

</template>

<script>
import PasteFromClipboard from '@/components/images/paste-from-clipboard.vue'
import {style_html} from './formatHtml.js'

import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'
import { Editor, EditorContent, VueNodeViewRenderer, 
  //BubbleMenu, 
  //FloatingMenu 
} from '@tiptap/vue-3'

//import StarterKit from '@tiptap/starter-kit'
import Bold from '@tiptap/extension-bold'
import Blockquote from '@tiptap/extension-blockquote'
import BulletList from '@tiptap/extension-bullet-list'
import Code from '@tiptap/extension-code'
import { Color } from '@tiptap/extension-color'
import { backgroundColor } from './background_color_extension.js'
import Dropcursor from '@tiptap/extension-dropcursor'
import Focus from '@tiptap/extension-focus'
import FontFamily from '@tiptap/extension-font-family'
import FontSize from './font_size_extension.js'
import Gapcursor from '@tiptap/extension-gapcursor'
import HardBreak from '@tiptap/extension-hard-break'
import Heading from '@tiptap/extension-heading'
import Highlight from '@tiptap/extension-highlight'
import History from '@tiptap/extension-history'
import HorizontalRule from '@tiptap/extension-horizontal-rule'
//import Image from '@tiptap/extension-image'
import Italic from '@tiptap/extension-italic'
import LineHeight from './line_height_extension.js'
import Link from '@tiptap/extension-link'
import ListItem from '@tiptap/extension-list-item'
import OrderedList from '@tiptap/extension-ordered-list'
import Strike from '@tiptap/extension-strike'
import Subscript from '@tiptap/extension-subscript'
import Superscript from '@tiptap/extension-superscript'
import Table from '@tiptap/extension-table'
//import TableCell from '@tiptap/extension-table-cell'
import ExtTableCell from './table_cell_background_color_extension.js' 
import TableHeader from '@tiptap/extension-table-header'
import TableRow from '@tiptap/extension-table-row'
import TaskItem from '@tiptap/extension-task-item'
import TaskList from '@tiptap/extension-task-list'
import TextAlign from '@tiptap/extension-text-align'
import TextStyle from '@tiptap/extension-text-style'
import Typography from '@tiptap/extension-typography'
import Underline from '@tiptap/extension-underline'

import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight'
import { lowlight } from 'lowlight'
import CodeBlockComponent from './CodeBlockComponent.vue'

import IFrame from './iframe-block-extension.js'
//import Twitter from './twitter.js'
//import Twitter2 from './twitter2.js'
import InstagramBlock from './instagram-block-extention.js'
import TwitterBlock from './twitter-block-extention.js'
import TelegramBlock from './telegram-block-extention.js'
import YoutubeBlock from './youtube-block-extention.js'

import ResizableImage from './image-block-extention.js';
import TocBlock from './toc-block-extension.js'
import TreeBlock from './tree-block-extension.js'
import LinkPreviewBlock from './linkpreview-block-extension.js'
//import { entries } from '@/gantt-elastic-header-master/webpack.config'

export default {
  components: {
    PasteFromClipboard, 

    EditorContent,
    //BubbleMenu,
    //FloatingMenu
  },

  props: ['modelValue', 'mode', 'allFunc', 'elId', 'ownr', 'height', 'prfx'
    , 
  ],

  data() {
    return {
      stickyResizeObserver: null,
      stickyParentElement: null,
      stickyElement: null,
      topHeight: 219,
      isEditable: false,
      edit: false,
      editor: null,
      isWView: true,
      isHView: false,
      textHTML: null,
      headOptions: [
        {text: 'h1'},
        {text: 'h2'},
        {text: 'h3'},
        {text: 'h4'},
        {text: 'h5'},
        {text: 'h6'},
      ],
      fontOptions: [
        {text: 'Arial'},
        {text: 'cursive'},
        {text: 'Courier New'},
        {text: 'Georgia'},
        {text: 'Helvetica'},
        {text: 'monospace'},
        {text: 'sans-serif'},
        {text: 'Tahoma'},
        {text: 'Times New Roman'}
      ],
      sizeOptions: [
        {text: '8'},
        {text: '9'},
        {text: '10'},
        {text: '11'},
        {text: '12'},
        {text: '14'},
        {text: '16'},
        {text: '18'},
        {text: '20'},
        {text: '22'},
        {text: '24'},
        {text: '26'},
        {text: '28'},
        {text: '36'},
        {text: '48'},
        {text: '72'}
      ],
      heightOptions: [
        {text: 0.8},
        {text: 0.9},
        {text: 1},
        {text: 1.1},
        {text: 1.2},
        {text: 1.3},
        {text: 1.4},
        {text: 1.5},
        {text: 1.6},
        {text: 1.7},
        {text: 1.8},
        {text: 1.9},
        {text: 2},
        {text: 2.2},
        {text: 2.5},
        {text: 3}
      ],
    }
  },

  watch: {
    isEditable(value) {
      this.editor.setEditable(value)
    },
  },

  mounted() {

    window.addEventListener('resize', this.setSticky);

    this.$nextTick(() => {
      // Add the component back in
      this.setSticky();
    })

    this.textHTML = this.modelValue

    let set_autofocus = true
    let set_modeFocus = 'all'
    let set_classFocus = 'has-focus'
    
    this.editor = new Editor({
      extensions: [
        //Twitter2,
        //Twitter,
        InstagramBlock,
        TelegramBlock,
        TwitterBlock,
        YoutubeBlock,

        Document,
        Paragraph,
        Text,
        
        ResizableImage.configure({
          inline: true
        }),
        TocBlock,
        TreeBlock,
        LinkPreviewBlock,
        
        //StarterKit,
        Bold,
        Blockquote,
        BulletList,
        Code,
        CodeBlockLowlight
          .extend({
            addNodeView() {
              return VueNodeViewRenderer(CodeBlockComponent)
            },
          })
          .configure({ lowlight }),
        Color,
        backgroundColor,
        Dropcursor,
        Focus.configure({
          className: set_classFocus,
          mode: set_modeFocus,
        }),
        FontFamily,
        FontSize,
        Gapcursor,
        HardBreak,
        Heading,
        Highlight,
        History,
        HorizontalRule,
        IFrame,
        //Image,
        Italic,
        LineHeight,
        Link.configure({
          openOnClick: true,
        }),
        ListItem,
        OrderedList,
        Strike,
        Subscript,
        Superscript,
        Table.configure({
          resizable: true,
        }),
        TableRow,
        TableHeader,
        //TableCell,
        ExtTableCell,
        TaskList,
        TaskItem.configure({
          nested: true,
        }),
        TextAlign.configure({
          types: ['heading', 'paragraph'],
        }),
        TextStyle,
        Typography,
        Underline,
      ],
      autofocus: set_autofocus,
      content: this.modelValue.svl,
      editorProps: {
        attributes: {
          spellcheck: 'false',
        },
      },
    })

    this.setMode ()
    
    //create editor.id property to identify instance for the TOC functionality
    if (this.edit) {
      this.editor.id = 'e';  
    } else {
      this.editor.id = this.elId;
    }

  },

  updated() {
    if (window.instgrm) {
      window.instgrm.Embeds.process()
    }

  },

  beforeUnmount() {
    this.editor.destroy()
    if (this.stickyResizeObserver) {
      this.stickyResizeObserver.unobserve(this.stickyParentElement);
    }
  },

  unmounted () {
    window.removeEventListener('resize', this.setSticky);
  },

  computed: {
    viewContentHeight () {
      let height = this.height + this.topHeight
      if (!this.edit) {
        height = height - 128
      }
      return 'calc(100vh - ' + height + 'px)'
    },

		showButton() {
			return this.editor?.state?.selection?.node?.type?.name === 'ResizableImage';
		},
		isDraggable() {
			return this.editor?.state?.selection?.node?.attrs?.isDraggable;
		},
    fontSelected() {
      return this.editor.getAttributes('textStyle').fontFamily
    }
	},

  methods: {
    setSticky () {
      this.stickyElement = document.getElementById('stickyEditorElement');
      this.stickyParentElement = document.getElementById('stickyParentElement');

      let elements = document.querySelectorAll('.ProseMirror');
      elements.forEach(element => {
        element.style.position = 'static';
      });

      if (this.mode == 'view') {
        elements = document.querySelectorAll('.code-block');
        elements.forEach(element => {
          element.style.position = 'static';
        });
      }

      elements = document.querySelectorAll('.twitter-block');
      elements.forEach(element => {
        element.style.position = 'static';
      });

      elements = document.querySelectorAll('.instagram-block');
      elements.forEach(element => {
        element.style.position = 'static';
      });

      elements = document.querySelectorAll('.telegram-block');
      elements.forEach(element => {
        element.style.position = 'static';
      });

      if (this.stickyParentElement) {
        this.stickyResizeObserver = new ResizeObserver(() => {

          const prevRect = this.stickyParentElement.getBoundingClientRect ();
          const rect = this.stickyElement.getBoundingClientRect();

          if (rect.x == prevRect.x) {

            this.stickyElement.style.top = (parseInt(getComputedStyle(this.stickyParentElement).top.replace("px", "")) 
              + parseInt(getComputedStyle(this.stickyParentElement).height.replace("px", ""))) + "px";
            this.stickyElement.style.position = "sticky";
          } else {
            this.stickyElement.style.top = getComputedStyle(this.stickyParentElement).top;
            this.stickyElement.style.position = "sticky";
          }
        })

        this.stickyResizeObserver.observe(this.stickyParentElement);
      }

    },

    setMode () {

      if (this.mode === 'edit') {
        this.edit = true
        this.isEditable = false

        const trick = this.ownr
        trick.editor = this.editor

      } else {
        this.edit = false
        this.isEditable = true
      }

      this.$nextTick(() => {
        //Add the component back in
        this.isEditable = !this.isEditable
      })
    },

    addImage() {
      const url = window.prompt('URL')
      
      //console.log('this.editor.chain().focus(): ', this.editor.chain().focus())
      
      if (url) {
        this.editor.chain().focus().setImage({ src: url }).run()
      }
    },

    toggleResize() {
      this.editor.chain().focus().toggleResizable().run();
    },

    outputHtml () {
      const vHtml = this.modelValue
      vHtml.svl = style_html( this.editor.getHTML(), {
        'indent_size': 2,
        'indent_char': ' ',
        'max_char': 78,
        'brace_style': 'expand',
        'unformatted': ['a', 'sub', 'sup', 'b', 'i', 'u', 's', 'span', 'pre', 'code']
      })
    },

    setHView () {
      this.outputHtml()
      
      this.isHView = true
      this.isWView = false
    },
    setWView () {
      //const vHtml = this.modelValue
      //vHtml.svl = this.textHTML.svl
      
      this.editor.commands.setContent(this.textHTML.svl)
      
      this.isHView = false
      this.isWView = true
    },

    getFontFamily () {
      const font = this.editor.getAttributes('textStyle').fontFamily
      const el = document.getElementById("fontSelect");
      //this.$refs.fontSelect.value = font
      if (el) {
        el.value = font
      //console.log('this.editor.getAttributes("textStyle").fontFamily: ', el, this.editor.getAttributes('textStyle').fontFamily)
      }

      if (font) {
        return true
      } else {
        return false
      }
    },

    getFontSize () {
      const size = this.editor.getAttributes('textStyle').fontSize
      const el = document.getElementById("sizeSelect");
      //this.$refs.fontSelect.value = font
      if (el) {
        if (size) {
          el.value = size.substring(0, size.length-2)
          //console.log('this.editor.getAttributes("textStyle").fontSize: ', el, this.editor.getAttributes('textStyle').fontSize)
          return true
        } else {
          el.value = size
          return false
        }
      } else {
        return false
      }

    },

    getLineHeight () {
      const height = this.editor.getAttributes('paragraph').lineHeight || this.editor.getAttributes('heading').lineHeight
      const el = document.getElementById("heightSelect");
      //this.$refs.fontSelect.value = font
      if (el) {
        if (height) {
          el.value = height
          //console.log('this.editor.getAttributes("paragraph").lineHeight: ', el, this.editor.getAttributes('paragraph').lineHeight, this.editor.getAttributes('heading').lineHeight)
          return true
        } else {
          el.value = height
          return false
        }
      } else {
        return false
      }

    },

    getTextColor () {
      const color = this.editor.getAttributes('textStyle').color
      const el = document.getElementById("text_color");
      //this.$refs.fontSelect.value = font
      if (el) {
          if (color) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
    },

    getTextBackgroundColor () {
      const color = this.editor.getAttributes('textStyle').backgroundColor
      const el = document.getElementById("text_backgroundcolor");
      //this.$refs.fontSelect.value = font
      if (el) {
          if (color) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
    },
    
    setFontFamily (event) {
      this.editor.chain().focus().setFontFamily(event.target.value).run()
    }, 

    setFontSize (event) {
     
      this.editor.chain().focus().setFontSize(event.target.value + 'px').run()
    },
    
    setLineHight (event) {
      this.editor.chain().focus().setLineHeight(event.target.value).run()
    },

    getHeading () {
      const level = this.editor.getAttributes('heading').level
      const el = document.getElementById("headSelect");
      //this.$refs.fontSelect.value = font
      if (el) {
        el.value = 'h' + level
      //console.log('this.editor.getAttributes("heading").level: ', el, this.editor.getAttributes('heading').level)
      }
      return this.editor.isActive('paragraph')
    },

    setHeading (event) {
      const nlevel = event.target.value.substring(1,2)
      this.editor.chain().focus().toggleHeading({ level: +nlevel }).run()
    },

    isList () {
      return this.editor.isActive('bulletList') || this.editor.isActive('orderedList')
    },

    isTask () {
      return this.editor.isActive('taskList')
    },

    isTable () {
      return this.editor.isActive('table')
    },

    setLink() {
      const previousUrl = this.editor.getAttributes('link').href
      const url = window.prompt('URL', previousUrl)

      // cancelled
      if (url === null) {
        return
      }

      // empty
      if (url === '') {
        this.editor
          .chain()
          .focus()
          .extendMarkRange('link')
          .unsetLink()
          .run()

        return
      }

      // update link
      this.editor
        .chain()
        .focus()
        .extendMarkRange('link')
        .setLink({ href: url })
        .run()
    },

    setIframe() {
      //const previousUrl = this.editor.getAttributes('iframe').parseHTML()
      const previousUrl = ''
      const embed = window.prompt('Embed <...>', previousUrl)

      // cancelled
      if (embed === null) {
        return
      }

      // empty
      if (embed === '') {
        //this.editor
        //  .chain()
        //  .focus()
        //  .extendMarkRange('link')
        //  .unsetLink()
        //  .run()

        return
      }

      // update link
      this.editor
        .chain()
        .focus()
        .insertContent(embed)
        //.extendMarkRange('iframe')
        //.setIframe({ hibiHtml: url })
        .run()
    },

    setYoutube() {
      const previousHtml = this.editor.getAttributes('youtube').hibiHtml
      //const previousUrl = ''
      let embed = window.prompt('Embed <...>', previousHtml)

      // cancelled
      if (embed === null) {
        return
      }

      // empty
      if (embed === '') {
        //this.editor
        //  .chain()
        //  .focus()
        //  .extendMarkRange('link')
        //  .unsetLink()
        //  .run()

        return
      }

      // update link
      embed = '<hibi-youtube>' + embed + '</hibi-youtube>'
      this.editor
        .chain()
        .focus()
        .insertContent(embed)
        //.extendMarkRange('iframe')
        //.setIframe({ hibiHtml: url })
        .run()
    },

    setTelegram() {
      const previousHtml = this.editor.getAttributes('youtube').hibiHtml
      //const previousUrl = ''
      let embed = window.prompt('Embed <...>', previousHtml)

      // cancelled
      if (embed === null) {
        return
      }

      // empty
      if (embed === '') {
        //this.editor
        //  .chain()
        //  .focus()
        //  .extendMarkRange('link')
        //  .unsetLink()
        //  .run()

        return
      }

      // update link
      embed = '<hibi-telegram>' + embed + '</hibi-telegram>'
      this.editor
        .chain()
        .focus()
        .insertContent(embed)
        //.extendMarkRange('iframe')
        //.setIframe({ hibiHtml: url })
        .run()
    },

    setTwitter() {
      const previousHtml = this.editor.getAttributes('youtube').hibiHtml
      //const previousUrl = ''
      let embed = window.prompt('Embed <...>', previousHtml)

      // cancelled
      if (embed === null) {
        return
      }

      // empty
      if (embed === '') {
        //this.editor
        //  .chain()
        //  .focus()
        //  .extendMarkRange('link')
        //  .unsetLink()
        //  .run()

        return
      }

      // update link
      embed = '<hibi-twitter-tweet>' + embed + '</hibi-twitter-tweet>'
      this.editor
        .chain()
        .focus()
        .insertContent(embed)
        //.extendMarkRange('iframe')
        //.setIframe({ hibiHtml: url })
        .run()
    },

    setInstagram() {
      const previousHtml = this.editor.getAttributes('youtube').hibiHtml
      //const previousUrl = ''
      let embed = window.prompt('Embed <...>', previousHtml)

      // cancelled
      if (embed === null) {
        return
      }

      // empty
      if (embed === '') {
        //this.editor
        //  .chain()
        //  .focus()
        //  .extendMarkRange('link')
        //  .unsetLink()
        //  .run()

        return
      }

      // update link
      embed = '<hibi-instagram-media>' + embed + '</hibi-instagram-media>'
      this.editor
        .chain()
        .focus()
        .insertContent(embed)
        //.extendMarkRange('iframe')
        //.setIframe({ hibiHtml: url })
        .run()
    },

    setTocBlock() {

      const embed = '<toc></toc>'
      this.editor
        .chain()
        .focus()
        .insertContent(embed)
        .run()

    },

    setTreeBlock() {

      // insert tree
      const embed = '<div data-type="tree-item"><p></p></div>'
      this.editor
        .chain()
        .focus()
        .insertContent(embed)
        .run()

    },

    setLinkPreviewBlock() {

      let embed = window.prompt('URL', '')

      // cancelled or empty
      if ((embed === null) || (embed === '')) {
        return
      }

      // insert link-preview
      embed = '<div data-type="link-preview" link="' + embed + '" uploaded="false">' + embed + '</div>'
      this.editor
        .chain()
        .focus()
        .insertContent(embed)
        .run()

    },

  },
}
</script>

<style lang="scss">
.content-edit {
  //height: 730px; //625px;
  overflow-y: auto;
  //scroll-behavior: auto;
  box-sizing: border-box;
  padding: 4px 4px 4px 4px;
  
  background-color: #FFF;
  color: #003300;
}

.content-view {
  //height: 700px;
  overflow-y: auto;
  //scroll-behavior: auto;
  box-sizing: border-box;
  padding: 4px 4px 4px 4px;
  margin-left: 0.5em;
  
  background-color: #FFF;
  color: #003300;
}

.content-view img {
  max-width: 100%;
}

/* Basic editor styles */
.has-focus {
  border-radius: 3px;
  //box-shadow: 0 0 0 3px #68cef8;
  box-shadow: 0 0 0 1px rgb(178,199,233);
}

.tab-selected {
  background-color: #616161;
  color: #FFF;
}

ul[data-type="taskList"] {
  list-style: none;
  padding: 0;

  p {
    margin: 0;
  }

  li {
    display: flex;

    > label {
      flex: 0 0 auto;
      margin-right: 0.5rem;
      user-select: none;
    }

    > div {
      flex: 1 1 auto;
    }
  }
}

#stickyEditorElement {
  position: sticky;
  background-color: var(--main-3-color);
}

.edit_menu {
  display: flex;
  flex-wrap: wrap;
  z-index: 100;
}

input[type=color] {
  display: inline-flex;
  //padding-top: 0px;
  width: 32px;
  height: 32px;
}

button.edit {
  display: inline-flex;
  padding: 0px 0px 0px 0px;
  width: 32px;
  height: 32px;
}
button.light {
  background-color: var(--light-color);
}
button.light.is-active, button:disabled {
  background-color: var(--light-set-color);
}

button.edit svg {
  color: var(--main-4-color);

  padding: 0px 0px 0px 0px;
  margin: 0px 0px 0px 0px ;
  display: inline-block;
  width: 28px;
  height: 28px;
  //vertical-align:top;

  //display: flex;
  //align-items:center;
  //justify-content: center;

//  max-height: 100%;
//  max-width: 100%;
//  position:relative ;
  //left: -50%;
//  transform: translateX(-50%);
//  -webkit-transform: translateX(-50%);
//  -ms-transform: translateX(-50%);
//  top: 50%;
//  transform: translateY(-50%);
//  -webkit-transform: translateY(-50%);
//  -ms-transform: translateY(-50%);
}


.ProseMirror {
  > * + * {
    margin-top: 0.75em;
  }

  //p {
  //  white-space: pre-line;
  //}

  p[style*="text-align: justify"] {
    white-space: pre-line;
  }

  > p {
    text-indent: 30px;
  }

  ul,
  ol {
    padding: 0 1rem;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 1.1;
  }

  code {
    background-color: rgba(#616161, 0.1);
    color: #616161;
  }

  pre {
    background: #0D0D0D;
    color: #FFF;
    font-family: 'JetBrainsMono', monospace;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;

    code {
      color: inherit;
      padding: 0;
      background: none;
      font-size: 0.8rem;
    }

    .hljs-comment,
    .hljs-quote {
      color: #616161;
    }

    .hljs-variable,
    .hljs-template-variable,
    .hljs-attribute,
      .hljs-tag,
    .hljs-name,
    .hljs-regexp,
    .hljs-link,
    .hljs-name,
    .hljs-selector-id,
    .hljs-selector-class {
      color: #F98181;
    }

    .hljs-number,
    .hljs-meta,
    .hljs-built_in,
    .hljs-builtin-name,
    .hljs-literal,
    .hljs-type,
    .hljs-params {
      color: #FBBC88;
    }

    .hljs-string,
    .hljs-symbol,
    .hljs-bullet {
      color: #B9F18D;
    }

    .hljs-title,
    .hljs-section {
      color: #FAF594;
    }

    .hljs-keyword,
    .hljs-selector-tag {
      color: #70CFF8;
    }

    .hljs-emphasis {
      font-style: italic;
    }

    .hljs-strong {
      font-weight: 700;
    }

  }

  img {
    max-width: 800;
    height: auto;
    max-height: 600px;
    //float: left;
    //padding-right: 10px;

    &.ProseMirror-selectednode {
      //outline: 3px solid #68CEF8;
      outline: 2px solid rgb(178,199,233);
    }
  }

  hr {
    margin: 1rem 0;
  }

  blockquote {
    padding-left: 1rem;
    border-left: 3px solid rgba(#0D0D0D, 0.1);
  }

  mark {
    background-color: #ffe066;
    padding: 0.125em 0;
    border-radius: 0.25em;
    box-decoration-break: clone;
  }

  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    margin: 0;
    overflow: hidden;

    td,
    th {
      min-width: 1em;
      border: 2px solid #ced4da;
      padding: 3px 5px;
      vertical-align: top;
      box-sizing: border-box;
      //position: relative;

      > * {
        margin-bottom: 0;
      }
    }

    th {
      font-weight: bold;
      text-align: left;
      background-color: #f1f3f5;
    }

    .selectedCell:after {
      z-index: 2;
      position: absolute;
      content: "";
      left: 0; right: 0; top: 0; bottom: 0;
      background: rgba(200, 200, 255, 0.4);
      pointer-events: none;
    }

    .column-resize-handle {
      position: absolute;
      right: -2px;
      top: 0;
      bottom: -2px;
      width: 4px;
      background-color: #adf;
      pointer-events: none;
    }

    p {
      margin: 0;
    }
  }

}

.tableWrapper {
  padding: 1rem 0;
  overflow-x: auto;
}

.resize-cursor {
  cursor: ew-resize;
  cursor: col-resize;
}

.is-active {
  background: #616161;
  color: #FFF;
}

.st0 {
  fill:none;
  stroke:#000000;
  stroke-width:2;
  stroke-linecap:round;
  stroke-linejoin:round;
  stroke-miterlimit:10;
}

.i_st01 {
  fill:#020202;
}

</style>